var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackPlanMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 166,
    viewBox: "0 0 375 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6001_52307)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 166,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.300781,
    width: 375,
    height: 812,
    fill: "url(#paint0_linear_6001_52307)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.300781,
    width: 375,
    height: 812,
    fill: "url(#paint1_linear_6001_52307)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.631 88.2902H128.643V88.306H128.631V88.2902Z",
    fill: "url(#paint2_linear_6001_52307)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-15.6789 105.265H-11.8993L-5.96615 61.0328H-4.51465L-1.3766 96.7094L0.440157 95.1338C0.589437 95.004 0.783213 94.9313 0.983312 94.9313H5.34421C5.54431 94.9313 5.73167 95.0009 5.88413 95.1274L17.7567 105.265H41.9337V92.3685C41.9337 92.1628 42.1053 91.9951 42.3117 91.9951C42.5182 91.9951 42.6865 91.8274 42.6865 91.6218V88.9957C42.6865 88.8755 42.7151 88.7553 42.7659 88.6477L46.0374 81.6142C46.1739 81.3232 46.4693 81.1365 46.7933 81.1365H70.7543C71.0656 81.1365 71.3515 81.3105 71.4944 81.5858L74.9818 88.3629C75.1216 88.6382 75.4106 88.8122 75.7219 88.8122H75.7917C76.2491 88.8122 76.6207 89.1824 76.6207 89.638V90.1474C76.6207 90.4227 76.4842 90.6821 76.2523 90.8371L76.1443 90.9067C75.9156 91.0586 75.7759 91.3181 75.7759 91.5933V105.265H80.4004L80.375 99.2184C80.3718 98.728 81.0705 98.6426 81.1912 99.1172L81.4707 100.25H81.6708L81.8455 99.0317C81.9154 98.5508 82.6173 98.5635 82.6713 99.0476L82.8016 100.25H83.332L83.5067 99.0317C83.5765 98.5508 84.2785 98.5635 84.3325 99.0476L84.4531 100.168H84.5898L84.7517 99.0349C84.8216 98.554 85.5235 98.5666 85.5775 99.0507L85.6982 100.171H86.2509L86.4129 99.0381C86.4827 98.5571 87.1847 98.5698 87.2387 99.0539L87.3594 100.174H87.496L87.658 99.0412C87.7278 98.5603 88.4297 98.573 88.4837 99.057L88.6044 100.177H88.741L88.903 99.0444C88.9729 98.5635 89.6748 98.5761 89.7288 99.0602L89.8495 100.18H90.1766L90.5133 98.8039C90.6308 98.3262 91.3359 98.4148 91.3296 98.9052L91.2788 105.281H96.6401V82.5539H96.7894L96.8752 81.8231C96.9292 81.3453 97.6216 81.3326 97.6978 81.8072L97.8153 82.5539H98.1393L98.2251 81.8231C98.279 81.3453 98.9715 81.3326 99.0477 81.8072L99.1747 82.6394H102.341L102.437 81.8231C102.491 81.3453 103.183 81.3326 103.259 81.8072L103.386 82.6394H103.688L103.783 81.8231C103.837 81.3453 104.53 81.3326 104.606 81.8072L104.733 82.6394H104.895V88.2554H105.568V75.84H105.686C105.686 75.84 105.689 75.8179 105.689 75.8084L105.807 74.2992C105.845 73.7961 106.582 73.7867 106.632 74.2897L106.785 75.7989C106.785 75.7989 106.788 75.8116 106.788 75.8179V75.8369L106.867 75.84V75.8084L106.985 74.2992C107.023 73.7961 107.76 73.7867 107.811 74.2897L107.97 75.7989V75.8242V75.84H109.11V64.8106C109.107 64.7852 109.107 64.7568 109.11 64.7283V64.5922H109.138L109.358 63.6937C109.456 63.2887 110.025 63.2697 110.155 63.662L110.463 64.5891H110.653L112.06 60.0551L112.747 51.1487C112.124 51.0727 111.638 50.5412 111.638 49.8989C111.638 49.2028 112.203 48.6396 112.905 48.6396C113.607 48.6396 114.166 49.2028 114.166 49.8989C114.166 50.595 113.601 51.1581 112.905 51.1581H112.883L113.493 60.0551L115.062 64.5891H115.329L115.405 64.1841C115.488 63.7475 116.11 63.7285 116.218 64.1619L116.323 64.5922H116.698V75.84H117.155V75.8084L117.273 74.2992C117.311 73.7961 118.048 73.7867 118.098 74.2897L118.257 75.7989V75.84H120.191V75.8084L120.309 74.2992C120.347 73.7961 121.084 73.7867 121.135 74.2897L121.294 75.7989V75.8242V75.84H121.424V88.2554H123.533V82.6394H123.695L123.822 81.8072C123.892 81.3295 124.584 81.3453 124.644 81.8231L124.737 82.6394H125.045L125.169 81.8072C125.245 81.3295 125.937 81.3453 125.994 81.8231L126.086 82.6394H129.256L129.383 81.8072C129.453 81.3295 130.146 81.3453 130.206 81.8231L130.289 82.5539H130.616L130.727 81.8072C130.803 81.3295 131.495 81.3453 131.553 81.8231L131.635 82.5539H131.702V105.281H140.633V99.4684C140.633 98.9716 141.351 98.8957 141.456 99.3829L141.647 100.269H141.882V100.259V100.247L142.034 99.4557C142.12 98.9969 142.784 99.0128 142.85 99.4747L142.968 100.266L143.127 100.269V100.259C143.127 100.259 143.127 100.25 143.13 100.247L143.279 99.4557C143.365 98.9969 144.029 99.0128 144.095 99.4747L144.213 100.266L144.785 100.269V100.247L144.937 99.4557C145.023 98.9969 145.687 99.0128 145.753 99.4747L145.871 100.266L148.104 100.269V100.247L148.256 99.4557C148.342 98.9969 149.006 99.0128 149.072 99.4747L149.19 100.266L150.317 100.269L150.508 99.3829C150.613 98.8989 151.331 98.9748 151.331 99.4684V105.281H154.894V102.265C154.894 102.132 154.926 102 154.99 101.882L158.067 96.045C158.207 95.7729 158.493 95.602 158.801 95.602H163.327C163.775 95.602 164.137 95.2413 164.137 94.7952C164.137 94.3491 164.499 93.9884 164.947 93.9884H166.548C167.005 93.9884 167.377 93.6182 167.377 93.1626V89.1634C167.377 88.7078 167.748 88.3376 168.206 88.3376H183.245C183.702 88.3376 184.074 88.7078 184.074 89.1634V93.1626C184.074 93.6182 184.445 93.9884 184.903 93.9884H185.351C185.808 93.9884 186.18 94.3586 186.18 94.8142V97.0163V148.605H-15.6789V105.265ZM128.643 88.2902H128.631V88.306H128.643V88.2902Z",
    fill: "url(#paint3_linear_6001_52307)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.647 59.2003C243.647 58.9831 243.826 58.8051 244.044 58.8051L244.625 26.0005L244.607 25.3943L244.637 25.3008L244.625 26.0005L245.597 58.8987C245.815 58.8987 245.994 59.0766 245.994 59.2939V63.2368H246.391C246.609 63.2368 246.787 63.4148 246.787 63.632V65.2218C247.075 65.4843 247.269 65.8493 247.305 66.2626L247.387 67.2883C247.514 68.7907 247.511 70.3021 247.372 71.8044L247.311 72.45C247.245 73.1741 246.694 73.7472 245.994 73.8619V77.4307H246.391C246.609 77.4307 246.787 77.6087 246.787 77.8259V78.2211C246.787 78.4383 246.609 78.6163 246.391 78.6163H245.994V80.5863H246.391C246.609 80.5863 246.787 80.7643 246.787 80.9815V81.7689C246.787 81.9861 246.609 82.1641 246.391 82.1641H245.994V85.3166H246.391C246.609 85.3166 246.787 85.4946 246.787 85.7118V86.4992C246.787 86.7164 246.609 86.8944 246.391 86.8944H245.994V87.2896H246.391C246.609 87.2896 246.787 87.4676 246.787 87.6848V88.4721C246.787 88.6894 246.609 88.8673 246.391 88.8673H245.994V89.6547H246.784C247.002 89.6547 247.181 89.8327 247.181 90.0499V92.8103C247.181 93.0275 247.002 93.2055 246.784 93.2055H246.388V101.484C246.606 101.484 246.784 101.662 246.784 101.879V102.666C246.784 102.883 246.606 103.061 246.388 103.061V103.849C246.606 103.849 246.784 104.027 246.784 104.244V105.031C246.784 105.248 246.606 105.426 246.388 105.426V114.492H247.178C247.396 114.492 247.575 114.67 247.575 114.887V119.002H250.567C251 119.002 251.357 119.355 251.357 119.789V120.402H259.458V117.931C259.458 117.696 259.271 117.506 259.034 117.506C258.798 117.506 258.607 117.316 258.607 117.08V115.581C258.607 115.237 258.326 114.956 257.978 114.956C257.544 114.956 257.239 114.519 257.393 114.112L261.145 104.253C261.26 103.945 261.551 103.743 261.884 103.743H308.637C308.919 103.743 309.176 103.888 309.319 104.129L315.245 114.118C315.463 114.489 315.2 114.956 314.764 114.956C314.461 114.956 314.207 115.204 314.207 115.512V116.715C314.207 117.15 313.855 117.503 313.416 117.503H313.295C312.862 117.503 312.505 117.856 312.505 118.29V120.396H317.705V101.375C317.705 101.179 317.865 101.019 318.062 101.019C318.259 101.019 318.422 100.859 318.422 100.663V93.5946C318.422 93.1602 318.774 92.8073 319.213 92.8073H332.259V92.0199C332.259 91.5855 332.614 91.2325 333.05 91.2325H336.62C336.968 91.2325 337.277 91.0062 337.377 90.6744L339.213 84.6951C339.312 84.3633 339.621 84.137 339.97 84.137H384.691C385.124 84.137 385.481 84.49 385.481 84.9244V120.399V162.049H188.414V120.314V104.995C188.414 104.832 188.466 104.672 188.56 104.54L196.267 93.6459C196.346 93.5343 196.449 93.4498 196.561 93.3955V93.115H219.913C220.261 93.115 220.57 93.3412 220.67 93.6731L222.505 99.6523C222.605 99.9842 222.914 100.21 223.262 100.21H226.833C227.266 100.21 227.623 100.563 227.623 100.998V120.311H234.746V119.699C234.746 119.264 235.101 118.911 235.537 118.911H242.066V114.797C242.066 114.579 242.245 114.401 242.463 114.401H243.253V105.336C243.035 105.336 242.857 105.158 242.857 104.941V104.153C242.857 103.936 243.035 103.758 243.253 103.758V102.971C243.035 102.971 242.857 102.793 242.857 102.576V101.788C242.857 101.571 243.035 101.393 243.253 101.393V93.115H242.857C242.638 93.115 242.46 92.937 242.46 92.7198V89.9594C242.46 89.7422 242.638 89.5642 242.857 89.5642H243.647V88.7769H243.25C243.032 88.7769 242.854 88.5989 242.854 88.3817V87.5943C242.854 87.3771 243.032 87.1991 243.25 87.1991H243.647V86.8039H243.25C243.032 86.8039 242.854 86.6259 242.854 86.4087V85.6213C242.854 85.4041 243.032 85.2261 243.25 85.2261H243.647V82.0736H243.25C243.032 82.0736 242.854 81.8956 242.854 81.6784V80.891C242.854 80.6738 243.032 80.4958 243.25 80.4958H243.647V78.5258H243.25C243.032 78.5258 242.854 78.3478 242.854 78.1306V77.7354C242.854 77.5182 243.032 77.3402 243.25 77.3402H243.647V73.7895C242.959 73.7503 242.384 73.2314 242.29 72.5405C242.009 70.4891 241.996 68.4136 242.254 66.3622L242.284 66.0967C242.339 65.6804 242.548 65.3214 242.854 65.074V63.5385C242.854 63.3213 243.032 63.1433 243.25 63.1433H243.647V59.2003Z",
    fill: "url(#paint4_linear_6001_52307)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.647 59.2003C243.647 58.9831 243.826 58.8051 244.044 58.8051L244.625 26.0005L244.607 25.3943L244.637 25.3008L244.625 26.0005L245.597 58.8987C245.815 58.8987 245.994 59.0766 245.994 59.2939V63.2368H246.391C246.609 63.2368 246.787 63.4148 246.787 63.632V65.2218C247.075 65.4843 247.269 65.8493 247.305 66.2626L247.387 67.2883C247.514 68.7907 247.511 70.3021 247.372 71.8044L247.311 72.45C247.245 73.1741 246.694 73.7472 245.994 73.8619V77.4307H246.391C246.609 77.4307 246.787 77.6087 246.787 77.8259V78.2211C246.787 78.4383 246.609 78.6163 246.391 78.6163H245.994V80.5863H246.391C246.609 80.5863 246.787 80.7643 246.787 80.9815V81.7689C246.787 81.9861 246.609 82.1641 246.391 82.1641H245.994V85.3166H246.391C246.609 85.3166 246.787 85.4946 246.787 85.7118V86.4992C246.787 86.7164 246.609 86.8944 246.391 86.8944H245.994V87.2896H246.391C246.609 87.2896 246.787 87.4676 246.787 87.6848V88.4721C246.787 88.6894 246.609 88.8673 246.391 88.8673H245.994V89.6547H246.784C247.002 89.6547 247.181 89.8327 247.181 90.0499V92.8103C247.181 93.0275 247.002 93.2055 246.784 93.2055H246.388V101.484C246.606 101.484 246.784 101.662 246.784 101.879V102.666C246.784 102.883 246.606 103.061 246.388 103.061V103.849C246.606 103.849 246.784 104.027 246.784 104.244V105.031C246.784 105.248 246.606 105.426 246.388 105.426V114.492H247.178C247.396 114.492 247.575 114.67 247.575 114.887V119.002H250.567C251 119.002 251.357 119.355 251.357 119.789V120.402H259.458V117.931C259.458 117.696 259.271 117.506 259.034 117.506C258.798 117.506 258.607 117.316 258.607 117.08V115.581C258.607 115.237 258.326 114.956 257.978 114.956C257.544 114.956 257.239 114.519 257.393 114.112L261.145 104.253C261.26 103.945 261.551 103.743 261.884 103.743H308.637C308.919 103.743 309.176 103.888 309.319 104.129L315.245 114.118C315.463 114.489 315.2 114.956 314.764 114.956C314.461 114.956 314.207 115.204 314.207 115.512V116.715C314.207 117.15 313.855 117.503 313.416 117.503H313.295C312.862 117.503 312.505 117.856 312.505 118.29V120.396H317.705V101.375C317.705 101.179 317.865 101.019 318.062 101.019C318.259 101.019 318.422 100.859 318.422 100.663V93.5946C318.422 93.1602 318.774 92.8073 319.213 92.8073H332.259V92.0199C332.259 91.5855 332.614 91.2325 333.05 91.2325H336.62C336.968 91.2325 337.277 91.0062 337.377 90.6744L339.213 84.6951C339.312 84.3633 339.621 84.137 339.97 84.137H384.691C385.124 84.137 385.481 84.49 385.481 84.9244V120.399V162.049H188.414V120.314V104.995C188.414 104.832 188.466 104.672 188.56 104.54L196.267 93.6459C196.346 93.5343 196.449 93.4498 196.561 93.3955V93.115H219.913C220.261 93.115 220.57 93.3412 220.67 93.6731L222.505 99.6523C222.605 99.9842 222.914 100.21 223.262 100.21H226.833C227.266 100.21 227.623 100.563 227.623 100.998V120.311H234.746V119.699C234.746 119.264 235.101 118.911 235.537 118.911H242.066V114.797C242.066 114.579 242.245 114.401 242.463 114.401H243.253V105.336C243.035 105.336 242.857 105.158 242.857 104.941V104.153C242.857 103.936 243.035 103.758 243.253 103.758V102.971C243.035 102.971 242.857 102.793 242.857 102.576V101.788C242.857 101.571 243.035 101.393 243.253 101.393V93.115H242.857C242.638 93.115 242.46 92.937 242.46 92.7198V89.9594C242.46 89.7422 242.638 89.5642 242.857 89.5642H243.647V88.7769H243.25C243.032 88.7769 242.854 88.5989 242.854 88.3817V87.5943C242.854 87.3771 243.032 87.1991 243.25 87.1991H243.647V86.8039H243.25C243.032 86.8039 242.854 86.6259 242.854 86.4087V85.6213C242.854 85.4041 243.032 85.2261 243.25 85.2261H243.647V82.0736H243.25C243.032 82.0736 242.854 81.8956 242.854 81.6784V80.891C242.854 80.6738 243.032 80.4958 243.25 80.4958H243.647V78.5258H243.25C243.032 78.5258 242.854 78.3478 242.854 78.1306V77.7354C242.854 77.5182 243.032 77.3402 243.25 77.3402H243.647V73.7895C242.959 73.7503 242.384 73.2314 242.29 72.5405C242.009 70.4891 241.996 68.4136 242.254 66.3622L242.284 66.0967C242.339 65.6804 242.548 65.3214 242.854 65.074V63.5385C242.854 63.3213 243.032 63.1433 243.25 63.1433H243.647V59.2003Z",
    fill: "url(#paint5_linear_6001_52307)",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.46 119.956H325.971V142.061H316.46V119.956Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.203 119.44H326.229V119.698H316.203V119.44Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.525 119.956H325.907V120.985H316.525V119.956Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.525 132.551H325.907V133.58H316.525V132.551Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.024 119.956H324.943V131.009H321.024V119.956Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.601 138.719H324.943V142.061H321.601V138.719Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.488 138.719H320.83V142.061H317.488V138.719Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.487 140.004H319.287V142.06H317.487V140.004Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.594 134.35H324.943V135.121H323.594V134.35Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.666 134.35H323.016V135.121H321.666V134.35Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.488 134.35H320.83V137.177H317.488V134.35Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.774 134.35H320.83V137.177H318.774V134.35Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.49 134.35H318.774V137.177H317.49V134.35Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.024 121.499H324.943V124.07H321.024V121.499Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.024 125.097H324.943V127.668H321.024V125.097Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.024 128.437H324.943V131.008H321.024V128.437Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.087 121.499H321.858V124.07H321.087V121.499Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.087 125.097H321.858V127.668H321.087V125.097Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.087 128.437H321.858V131.008H321.087V128.437Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.525 131.522H325.907V131.78H316.525V131.522Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.489 121.499H319.159V124.07H317.489V121.499Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.489 125.097H319.159V127.668H317.489V125.097Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.489 128.437H319.159V131.008H317.489V128.437Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.489 121.499H318.003V124.07H317.489V121.499Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.489 125.097H318.003V127.668H317.489V125.097Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.489 128.437H318.003V131.008H317.489V128.437Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.309 121.499H323.979V124.07H322.309V121.499Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.309 125.097H323.979V127.668H322.309V125.097Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.309 128.437H323.979V131.008H322.309V128.437Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.183 123.147H276.252V142.426H228.183V123.147Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.183 136.514H276.252V142.426H228.183V136.514Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.911 127.004H273.939V129.575H272.911V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.772 124.561H277.668V125.332H226.772V124.561Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.911 132.401H273.939V134.973H272.911V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.653 137.801H275.225V142.428H272.653V137.801Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.485 137.801H270.341V142.428H266.485V137.801Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.83 137.801H264.686V142.428H260.83V137.801Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.174 137.801H259.03V142.428H255.174V137.801Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.89 138.698C253.89 137.775 253.142 137.027 252.219 137.027C251.297 137.027 250.549 137.775 250.549 138.698V142.426H253.892V138.698H253.89Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.407 137.801H249.263V142.428H245.407V137.801Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.751 137.801H243.607V142.428H239.751V137.801Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.84 137.801H237.696V142.428H233.84V137.801Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.471 137.801H231.784V142.428H229.471V137.801Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.653 138.57H275.225V142.426H272.653V138.57Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.485 138.57H270.341V142.426H266.485V138.57Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.83 138.57H264.686V142.426H260.83V138.57Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.174 138.57H259.03V142.426H255.174V138.57Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.89 139.471C253.89 138.548 253.142 137.801 252.219 137.801C251.297 137.801 250.549 138.548 250.549 139.471V142.428H253.892V139.471H253.89Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.407 138.57H249.263V142.426H245.407V138.57Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.751 138.57H243.607V142.426H239.751V138.57Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.84 138.57H237.696V142.426H233.84V138.57Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.471 138.57H231.784V142.426H229.471V138.57Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.54 127.004H269.569V129.575H268.54V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.54 132.401H269.569V134.973H268.54V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.714 127.004H266.743V129.575H265.714V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.714 132.401H266.743V134.973H265.714V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.886 127.004H263.915V129.575H262.886V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.886 132.401H263.915V134.973H262.886V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.315 127.004H261.344V129.575H260.315V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.315 132.401H261.344V134.973H260.315V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.23 127.004H258.259V129.575H257.23V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.23 132.401H258.259V134.973H257.23V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.661 127.004H255.689V129.575H254.661V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.661 132.401H255.689V134.973H254.661V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.576 127.004H252.604V129.575H251.576V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.576 132.401H252.604V134.973H251.576V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.492 127.004H249.521V129.575H248.492V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.492 132.401H249.521V134.973H248.492V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.663 127.004H246.692V129.575H245.663V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.663 132.401H246.692V134.973H245.663V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.093 127.004H244.122V129.575H243.093V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.093 132.401H244.122V134.973H243.093V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.009 127.004H241.038V129.575H240.009V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.009 132.401H241.038V134.973H240.009V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.18 127.004H238.209V129.575H237.18V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.18 132.401H238.209V134.973H237.18V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.612 127.004H235.641V129.575H234.612V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.612 132.401H235.641V134.973H234.612V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.497 127.004H231.526V129.575H230.497V127.004Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.497 132.401H231.526V134.973H230.497V132.401Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.414 123.147H277.023V124.69H227.414V123.147Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.882 123.661H276.252V124.175H271.882V123.661Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.715 123.661H270.085V124.175H265.715V123.661Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.546 123.661H263.915V124.175H259.546V123.661Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.377 123.661H257.746V124.175H253.377V123.661Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.207 123.661H251.576V124.175H247.207V123.661Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.039 123.661H245.408V124.175H241.039V123.661Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.869 123.661H239.238V124.175H234.869V123.661Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.699 123.661H233.068V124.175H228.699V123.661Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.447 121.992L250.699 122.043L250.658 122.249H250.447V121.992ZM249.393 121.992H249.135V121.734H249.393V121.992ZM249.393 123.276V123.534H249.135V123.276H249.393ZM254.533 123.276H254.791V123.534H254.533V123.276ZM254.533 121.992V121.734H254.791V121.992H254.533ZM253.479 121.992V122.249H253.268L253.227 122.043L253.479 121.992ZM250.447 122.249H249.393V121.736H250.447V122.249ZM249.648 121.992V123.276H249.135V121.992H249.648ZM249.393 123.019H254.533V123.532H249.393V123.019ZM254.276 123.276V121.992H254.789V123.276H254.276ZM254.533 122.249H253.479V121.736H254.533V122.249ZM253.227 122.043C253.133 121.575 252.715 121.221 252.22 121.221V120.707C252.965 120.707 253.587 121.236 253.731 121.941L253.227 122.043ZM252.22 121.221H251.706V120.707H252.22V121.221ZM251.706 121.221C251.21 121.221 250.793 121.575 250.699 122.043L250.195 121.941C250.339 121.236 250.961 120.707 251.706 120.707V121.221Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.446 121.992H249.391V123.277H254.532V121.992H253.478C253.36 121.406 252.84 120.963 252.219 120.963H251.705C251.083 120.963 250.564 121.404 250.446 121.992Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.294 130.236H235.114V142.06H214.294V130.236Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.294 137.947H235.114V142.059H214.294V137.947Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.487 139.49H232.287V142.062H230.487V139.49Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.145 139.49H228.945V142.062H227.145V139.49Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.289 139.49H225.089V142.062H223.289V139.49Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.948 139.49H221.748V142.062H219.948V139.49Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.349 139.49H218.149V142.062H216.349V139.49Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.487 132.807H232.287V136.663H230.487V132.807Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.145 132.807H228.945V136.663H227.145V132.807Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.289 132.807H225.089V136.663H223.289V132.807Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.948 132.807H221.748V136.663H219.948V132.807Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.918 136.407H231V137.95H218.918V136.407Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.349 132.807H218.149V136.663H216.349V132.807Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.704 125.112L234.71 130.237H214.696L224.702 125.112H224.704Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.886 131.009L236.529 130.366L224.578 124.068L213.011 130.366L213.525 131.009L224.578 125.097L235.888 131.009H235.886Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.621 139.021H230.101V139.876H232.673V139.021H232.153C232.112 138.635 231.784 138.336 231.388 138.336C230.993 138.336 230.664 138.635 230.623 139.021H230.621Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.621 139.021L230.875 139.048L230.849 139.276H230.621V139.019V139.021ZM230.102 139.021H229.844V138.763H230.102V139.021ZM230.102 139.876V140.134H229.844V139.876H230.102ZM232.673 139.876H232.931V140.134H232.673V139.876ZM232.673 139.021V138.763H232.931V139.021H232.673ZM232.154 139.021V139.278H231.925L231.9 139.05L232.154 139.022V139.021ZM230.621 139.278H230.102V138.765H230.621V139.278ZM230.359 139.021V139.876H229.846V139.021H230.359ZM230.102 139.621H232.673V140.134H230.102V139.621ZM232.415 139.876V139.021H232.929V139.876H232.415ZM232.673 139.278H232.154V138.765H232.673V139.278ZM231.898 139.048C231.87 138.79 231.652 138.592 231.386 138.592V138.078C231.915 138.078 232.35 138.478 232.409 138.993L231.898 139.05V139.048ZM231.386 138.592C231.121 138.592 230.902 138.792 230.875 139.048L230.363 138.991C230.422 138.478 230.857 138.076 231.386 138.076V138.59V138.592Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.278 139.021H226.759V139.876H229.33V139.021H228.811C228.769 138.635 228.441 138.336 228.045 138.336C227.65 138.336 227.321 138.635 227.28 139.021H227.278Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.278 139.021L227.532 139.048L227.506 139.276H227.278V139.019V139.021ZM226.759 139.021H226.501V138.763H226.759V139.021ZM226.759 139.876V140.134H226.501V139.876H226.759ZM229.33 139.876H229.588V140.134H229.33V139.876ZM229.33 139.021V138.763H229.588V139.021H229.33ZM228.811 139.021V139.278H228.583L228.557 139.05L228.811 139.022V139.021ZM227.278 139.278H226.759V138.765H227.278V139.278ZM227.017 139.021V139.876H226.503V139.021H227.017ZM226.759 139.621H229.33V140.134H226.759V139.621ZM229.072 139.876V139.021H229.586V139.876H229.072ZM229.33 139.278H228.811V138.765H229.33V139.278ZM228.557 139.048C228.529 138.79 228.311 138.592 228.045 138.592V138.078C228.575 138.078 229.009 138.478 229.068 138.993L228.557 139.05V139.048ZM228.045 138.592C227.78 138.592 227.561 138.792 227.534 139.048L227.022 138.991C227.081 138.478 227.516 138.076 228.045 138.076V138.59V138.592Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.425 139.021H222.905V139.876H225.477V139.021H224.957C224.916 138.635 224.587 138.336 224.192 138.336C223.796 138.336 223.468 138.635 223.427 139.021H223.425Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.425 139.021L223.678 139.048L223.653 139.276H223.425V139.019V139.021ZM222.905 139.021H222.648V138.763H222.905V139.021ZM222.905 139.876V140.134H222.648V139.876H222.905ZM225.475 139.876H225.732V140.134H225.475V139.876ZM225.475 139.021V138.763H225.732V139.021H225.475ZM224.955 139.021V139.278H224.727L224.702 139.05L224.955 139.022V139.021ZM223.425 139.278H222.905V138.765H223.425V139.278ZM223.161 139.021V139.876H222.648V139.021H223.161ZM222.905 139.621H225.477V140.134H222.905V139.621ZM225.219 139.876V139.021H225.732V139.876H225.219ZM225.475 139.278H224.955V138.765H225.475V139.278ZM224.702 139.048C224.674 138.79 224.456 138.592 224.19 138.592V138.078C224.719 138.078 225.154 138.478 225.213 138.993L224.702 139.05V139.048ZM224.19 138.592C223.924 138.592 223.706 138.792 223.678 139.048L223.167 138.991C223.226 138.478 223.661 138.076 224.19 138.076V138.59V138.592Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.081 139.021H219.561V139.876H222.133V139.021H221.613C221.572 138.635 221.244 138.336 220.848 138.336C220.453 138.336 220.124 138.635 220.083 139.021H220.081Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.082 139.021L220.336 139.048L220.31 139.276H220.082V139.019V139.021ZM219.562 139.021H219.305V138.763H219.562V139.021ZM219.562 139.876V140.134H219.305V139.876H219.562ZM222.134 139.876H222.392V140.134H222.134V139.876ZM222.134 139.021V138.763H222.392V139.021H222.134ZM221.614 139.021V139.278H221.386L221.361 139.05L221.614 139.022V139.021ZM220.082 139.278H219.562V138.765H220.082V139.278ZM219.82 139.021V139.876H219.307V139.021H219.82ZM219.562 139.621H222.134V140.134H219.562V139.621ZM221.876 139.876V139.021H222.39V139.876H221.876ZM222.134 139.278H221.614V138.765H222.134V139.278ZM221.359 139.048C221.331 138.79 221.113 138.592 220.847 138.592V138.078C221.376 138.078 221.811 138.478 221.87 138.993L221.359 139.05V139.048ZM220.847 138.592C220.582 138.592 220.363 138.792 220.336 139.048L219.824 138.991C219.883 138.478 220.318 138.076 220.847 138.076V138.59V138.592Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.483 139.021H215.964V139.876H218.535V139.021H218.016C217.974 138.635 217.646 138.336 217.25 138.336C216.855 138.336 216.526 138.635 216.485 139.021H216.483Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.483 139.021L216.737 139.048L216.711 139.276H216.483V139.019V139.021ZM215.964 139.021H215.706V138.763H215.964V139.021ZM215.964 139.876V140.134H215.706V139.876H215.964ZM218.533 139.876H218.791V140.134H218.533V139.876ZM218.533 139.021V138.763H218.791V139.021H218.533ZM218.016 139.021V139.278H217.788L217.762 139.05L218.016 139.022V139.021ZM216.483 139.278H215.964V138.765H216.483V139.278ZM216.222 139.021V139.876H215.708V139.021H216.222ZM215.964 139.621H218.535V140.134H215.964V139.621ZM218.278 139.876V139.021H218.791V139.876H218.278ZM218.533 139.278H218.014V138.765H218.533V139.278ZM217.76 139.048C217.733 138.79 217.514 138.592 217.249 138.592V138.078C217.778 138.078 218.213 138.478 218.272 138.993L217.76 139.05V139.048ZM217.249 138.592C216.983 138.592 216.765 138.792 216.737 139.048L216.226 138.991C216.285 138.478 216.719 138.076 217.249 138.076V138.59V138.592Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.229 131.649C230.229 131.673 230.243 131.71 230.29 131.756C230.339 131.803 230.416 131.85 230.524 131.893C230.737 131.98 231.044 132.035 231.386 132.035C231.728 132.035 232.033 131.98 232.248 131.893C232.356 131.85 232.433 131.803 232.482 131.756C232.531 131.708 232.543 131.673 232.543 131.649C232.543 131.626 232.529 131.588 232.482 131.543C232.433 131.496 232.356 131.449 232.248 131.405C232.035 131.319 231.728 131.264 231.386 131.264C231.044 131.264 230.739 131.319 230.524 131.405C230.416 131.449 230.339 131.496 230.29 131.543C230.241 131.59 230.229 131.626 230.229 131.649Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.889 131.649C226.889 131.673 226.902 131.71 226.95 131.756C226.999 131.803 227.075 131.85 227.184 131.893C227.396 131.98 227.703 132.035 228.045 132.035C228.388 132.035 228.693 131.98 228.907 131.893C229.015 131.85 229.092 131.803 229.141 131.756C229.19 131.708 229.202 131.673 229.202 131.649C229.202 131.626 229.188 131.588 229.141 131.543C229.092 131.496 229.015 131.449 228.907 131.405C228.695 131.319 228.388 131.264 228.045 131.264C227.703 131.264 227.398 131.319 227.184 131.405C227.075 131.449 226.999 131.496 226.95 131.543C226.9 131.59 226.889 131.626 226.889 131.649Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.032 131.649C223.032 131.673 223.046 131.71 223.093 131.756C223.142 131.803 223.219 131.85 223.327 131.893C223.54 131.98 223.847 132.035 224.189 132.035C224.531 132.035 224.836 131.98 225.051 131.893C225.159 131.85 225.236 131.803 225.285 131.756C225.334 131.708 225.346 131.673 225.346 131.649C225.346 131.626 225.332 131.588 225.285 131.543C225.236 131.496 225.159 131.449 225.051 131.405C224.838 131.319 224.531 131.264 224.189 131.264C223.847 131.264 223.542 131.319 223.327 131.405C223.219 131.449 223.142 131.496 223.093 131.543C223.044 131.59 223.032 131.626 223.032 131.649Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.69 131.649C219.69 131.673 219.704 131.71 219.751 131.756C219.8 131.803 219.877 131.85 219.985 131.893C220.198 131.98 220.505 132.035 220.847 132.035C221.189 132.035 221.494 131.98 221.709 131.893C221.817 131.85 221.894 131.803 221.943 131.756C221.992 131.708 222.004 131.673 222.004 131.649C222.004 131.626 221.99 131.588 221.943 131.543C221.894 131.496 221.817 131.449 221.709 131.405C221.496 131.319 221.189 131.264 220.847 131.264C220.505 131.264 220.2 131.319 219.985 131.405C219.877 131.449 219.8 131.496 219.751 131.543C219.702 131.59 219.69 131.626 219.69 131.649Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.092 131.649C216.092 131.673 216.105 131.71 216.153 131.756C216.202 131.803 216.279 131.85 216.387 131.893C216.599 131.98 216.906 132.035 217.248 132.035C217.591 132.035 217.896 131.98 218.11 131.893C218.218 131.85 218.295 131.803 218.344 131.756C218.393 131.708 218.405 131.673 218.405 131.649C218.405 131.626 218.391 131.588 218.344 131.543C218.295 131.496 218.218 131.449 218.11 131.405C217.898 131.319 217.591 131.264 217.248 131.264C216.906 131.264 216.601 131.319 216.387 131.405C216.279 131.449 216.202 131.496 216.153 131.543C216.103 131.59 216.092 131.626 216.092 131.649Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.574 126.767L228.045 128.437H221.362L224.574 126.767Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.581 142.826L160.47 144.173C158.331 144.41 156.281 143.263 155.365 141.317L154.768 140.048C154.567 139.623 154.476 139.155 154.5 138.687L154.567 137.427C154.703 134.8 158.26 134.099 159.382 136.477L160.004 134.458C160.814 131.822 164.537 131.806 165.372 134.435C165.708 130.686 170.639 129.547 172.583 132.77L173.09 131.97C174.471 129.784 177.465 129.323 179.444 130.988C181.146 132.422 181.458 134.926 180.161 136.734L178.843 138.572C180.67 139.133 180.447 141.784 178.555 142.034L172.583 142.824L172.581 142.826Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.202567
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.101 142.825L161.292 144.124C159.165 144.379 157.107 143.257 156.171 141.328L155.754 140.467C155.563 140.076 155.472 139.645 155.495 139.211L155.543 138.182C155.655 135.766 158.916 135.093 159.973 137.267L160.514 135.512C161.258 133.086 164.681 133.051 165.473 135.462C165.761 132.055 170.227 130.983 172.032 133.888L172.103 134.005L172.551 133.306C173.823 131.323 176.541 130.9 178.358 132.401C179.955 133.722 180.248 136.059 179.029 137.735L177.905 139.278C179.495 139.766 179.268 142.086 177.613 142.256L172.105 142.823L172.101 142.825Z",
    fill: "#63B19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.472 142.647L204.8 139.313C206.853 138.232 208.099 136.067 208.005 133.75L207.913 131.582C207.891 131.021 207.729 130.477 207.441 129.993L206.677 128.697C205.078 125.992 200.927 127.216 201.055 130.356L199.282 128.564C196.965 126.222 193.015 128.266 193.588 131.51C191.162 127.727 185.311 129.251 185.035 133.738L184.058 133.172C181.385 131.624 177.962 132.79 176.789 135.646C175.78 138.106 176.837 140.929 179.21 142.124L181.619 143.341H195.673C196.65 143.341 197.611 143.104 198.474 142.649L198.472 142.647Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.24189
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.595 142.647L312.923 139.313C314.976 138.232 316.222 136.067 316.128 133.75L316.036 131.582C316.014 131.021 315.852 130.477 315.564 129.993L314.8 128.697C313.201 125.992 309.05 127.216 309.178 130.356L307.405 128.564C305.088 126.222 301.138 128.266 301.711 131.51C299.285 127.727 293.434 129.251 293.158 133.738L292.181 133.172C289.508 131.624 286.085 132.79 284.912 135.646C283.903 138.106 284.96 140.929 287.333 142.124L289.742 143.341H303.796C304.773 143.341 305.734 143.104 306.597 142.649L306.595 142.647Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.24189
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.889 141.507L204.933 139.862C206.399 138.684 207.229 136.887 207.173 135.008L207.101 132.574C207.088 132.057 206.943 131.551 206.68 131.104L206.06 130.042C204.607 127.548 200.785 128.636 200.865 131.522L199.326 129.964C197.195 127.809 193.555 129.664 194.048 132.656C191.859 129.21 186.54 130.545 186.238 134.618L186.225 134.783L185.362 134.292C182.921 132.896 179.808 133.953 178.72 136.546C177.762 138.827 178.741 141.461 180.959 142.562L183.003 143.573H194.046L199.921 142.784C201.005 142.639 202.033 142.199 202.887 141.512L202.889 141.507Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.012 141.507L313.056 139.862C314.522 138.684 315.352 136.887 315.296 135.008L315.224 132.574C315.212 132.057 315.066 131.551 314.803 131.104L314.183 130.042C312.73 127.548 308.908 128.636 308.988 131.522L307.449 129.964C305.318 127.809 301.678 129.664 302.171 132.656C299.982 129.21 294.663 130.545 294.361 134.618L294.348 134.783L293.485 134.292C291.044 132.896 287.931 133.953 286.843 136.546C285.885 138.827 286.864 141.461 289.083 142.562L291.126 143.573H302.169L308.044 142.784C309.128 142.639 310.156 142.199 311.01 141.512L311.012 141.507Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.882 138.401C228.003 137.476 227.828 136.087 228.451 134.974L231.988 128.641C232.333 128.025 233.218 128.025 233.562 128.641L237.202 135.16C237.771 136.176 237.647 137.439 236.893 138.326C236.364 138.95 235.587 139.308 234.766 139.308H230.995C230.196 139.308 229.433 138.979 228.882 138.401Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.095 138.531C228.247 137.74 228.079 136.457 228.695 135.475L231.646 130.795C232.048 130.156 232.982 130.156 233.384 130.795L236.754 136.142C237.131 136.744 237.053 137.527 236.561 138.043C235.862 138.771 234.898 139.182 233.889 139.182H230.739C230.128 139.182 229.539 138.95 229.091 138.533L229.095 138.531Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.773 132.755V142.265",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.701 133.526L232.901 135.327",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.845 135.58L232.646 137.38",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.104 133.526L232.904 135.327",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.038 142.119C221.842 141.043 222.013 139.123 223.376 138.273L225.641 136.865C225.991 136.648 226.436 136.656 226.774 136.888L228.785 138.259C230.085 139.149 230.258 141 229.145 142.114C229.129 142.127 229.111 142.135 229.092 142.135H223.081C223.065 142.135 223.05 142.129 223.038 142.118V142.119Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.038 142.118C223.05 142.129 223.065 142.135 223.081 142.135H229.092C229.111 142.135 229.129 142.127 229.145 142.114C230.258 141 230.085 139.149 228.785 138.259L226.774 136.888C226.436 136.656 225.991 136.648 225.641 136.865L223.376 138.273C222.013 139.123 221.842 141.043 223.038 142.119V142.118ZM223.038 142.118L222.951 142.214",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.703 141.954C221.922 141.016 222.173 139.599 223.23 138.985L225.764 137.516C226.043 137.354 226.392 137.358 226.667 137.526L228.404 138.586C229.64 139.34 229.728 141.1 228.573 141.974C228.548 141.996 228.514 142.005 228.479 142.005H222.821C222.774 142.005 222.734 141.986 222.703 141.95V141.954Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.834 139.951V142.007",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.503 139.438L225.833 140.98",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.549 140.208L225.834 141.623",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9826 143.18L34.8711 144.527C32.732 144.764 30.6821 143.618 29.7665 141.671L29.1689 140.403C28.9684 139.978 28.8772 139.51 28.9015 139.042L28.9684 137.782C29.1041 135.154 32.6612 134.454 33.7834 136.832L34.4052 134.812C35.2155 132.177 38.9387 132.161 39.7733 134.79C40.1095 131.04 45.04 129.902 46.9846 133.125L47.4911 132.325C48.8726 130.139 51.8665 129.677 53.8456 131.342C55.5471 132.776 55.8591 135.28 54.5627 137.089L53.2439 138.926C55.0711 139.487 54.8483 142.139 52.9563 142.388L46.9846 143.178L46.9826 143.18Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.202567
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5024 143.18L35.6934 144.478C33.5665 144.733 31.5084 143.611 30.5725 141.683L30.1552 140.822C29.9648 140.431 29.8737 139.999 29.8959 139.566L29.9446 138.537C30.056 136.12 33.3173 135.448 34.3747 137.621L34.9156 135.867C35.659 133.44 39.0824 133.406 39.8744 135.816C40.162 132.409 44.6287 131.338 46.4335 134.242L46.5044 134.36L46.9521 133.661C48.2242 131.678 50.9427 131.254 52.7597 132.756C54.3559 134.076 54.6496 136.414 53.4302 138.089L52.3059 139.633C53.8961 140.121 53.6692 142.44 52.0142 142.61L46.5064 143.178L46.5024 143.18Z",
    fill: "#63B19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8733 143L79.2011 139.667C81.2547 138.586 82.5005 136.421 82.4061 134.103L82.3142 131.936C82.2924 131.375 82.1304 130.831 81.8425 130.347L81.0782 129.05C79.4793 126.346 75.3284 127.57 75.4566 130.71L73.6836 128.917C71.3662 126.576 67.4162 128.62 67.9894 131.863C65.5633 128.08 59.712 129.604 59.4362 134.091L58.459 133.525C55.7861 131.977 52.3634 133.143 51.1902 136C50.1815 138.46 51.2386 141.283 53.6115 142.478L56.0207 143.694H70.0746C71.0518 143.694 72.0121 143.457 72.8756 143.002L72.8733 143Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.24189
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.996 143L187.324 139.667C189.378 138.586 190.624 136.421 190.529 134.103L190.437 131.936C190.415 131.375 190.253 130.831 189.966 130.347L189.201 129.05C187.602 126.346 183.451 127.57 183.58 130.71L181.807 128.917C179.489 126.576 175.539 128.62 176.112 131.863C173.686 128.08 167.835 129.604 167.559 134.091L166.582 133.525C163.909 131.977 160.486 133.143 159.313 136C158.305 138.46 159.362 141.283 161.735 142.478L164.144 143.694H178.198C179.175 143.694 180.135 143.457 180.999 143.002L180.996 143Z",
    fill: "#8AD6C4",
    stroke: "#615E66",
    strokeWidth: 0.24189
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2906 141.861L79.3346 140.216C80.8005 139.038 81.6302 137.241 81.5745 135.361L81.5019 132.928C81.4898 132.41 81.3447 131.905 81.0811 131.457L80.4618 130.395C79.008 127.901 75.1862 128.99 75.266 131.876L73.7276 130.318C71.5965 128.163 67.9561 130.018 68.4496 133.01C66.2604 129.563 60.9413 130.898 60.6389 134.972L60.6268 135.136L59.7632 134.645C57.3226 133.249 54.2095 134.307 53.1209 136.9C52.1631 139.181 53.1427 141.815 55.3609 142.915L57.4048 143.927H68.4471L74.3227 143.138C75.4063 142.993 76.4344 142.553 77.2882 141.866L77.2906 141.861Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.414 141.861L187.458 140.216C188.924 139.038 189.753 137.241 189.698 135.361L189.625 132.928C189.613 132.41 189.468 131.905 189.204 131.457L188.585 130.395C187.131 127.901 183.309 128.99 183.389 131.876L181.851 130.318C179.72 128.163 176.079 130.018 176.573 133.01C174.383 129.563 169.064 130.898 168.762 134.972L168.75 135.136L167.886 134.645C165.446 133.249 162.332 134.307 161.244 136.9C160.286 139.181 161.266 141.815 163.484 142.915L165.528 143.927H176.57L182.446 143.138C183.529 142.993 184.557 142.553 185.411 141.866L185.414 141.861Z",
    fill: "#68B4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.283 138.755C102.404 137.831 102.229 136.442 102.853 135.328L106.39 128.995C106.734 128.379 107.619 128.379 107.964 128.995L111.603 135.515C112.172 136.53 112.048 137.793 111.295 138.68C110.765 139.304 109.988 139.662 109.168 139.662H105.396C104.598 139.662 103.834 139.334 103.283 138.755Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.496 138.885C102.648 138.094 102.481 136.812 103.097 135.83L106.048 131.149C106.449 130.51 107.384 130.51 107.785 131.149L111.155 136.497C111.533 137.099 111.454 137.882 110.962 138.397C110.264 139.125 109.3 139.536 108.291 139.536H105.141C104.529 139.536 103.941 139.304 103.492 138.887L103.496 138.885Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.175 133.108V142.619",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.103 133.881L107.302 135.681",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.247 135.935L107.047 137.735",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.505 133.881L107.305 135.681",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4373 142.474C96.2411 141.398 96.4123 139.478 97.7757 138.628L100.04 137.219C100.39 137.003 100.835 137.011 101.173 137.243L103.184 138.614C104.484 139.503 104.658 141.355 103.544 142.468C103.528 142.482 103.511 142.49 103.491 142.49H97.4806C97.4648 142.49 97.4491 142.484 97.4373 142.472V142.474Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.4373 142.472C97.4491 142.484 97.4648 142.49 97.4806 142.49H103.491C103.511 142.49 103.528 142.482 103.544 142.468C104.658 141.355 104.484 139.503 103.184 138.614L101.173 137.243C100.835 137.011 100.39 137.003 100.04 137.219L97.7757 138.628C96.4123 139.478 96.2411 141.398 97.4373 142.474V142.472ZM97.4373 142.472L97.3508 142.568",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.104 142.308C96.323 141.369 96.5748 139.953 97.6313 139.339L100.165 137.869C100.445 137.708 100.793 137.712 101.068 137.879L102.805 138.94C104.041 139.693 104.13 141.454 102.975 142.327C102.949 142.349 102.916 142.359 102.88 142.359H97.2221C97.1749 142.359 97.1355 142.339 97.104 142.304V142.308Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.234 140.306V142.362",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.903 139.792L100.233 141.334",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9497 140.562L100.234 141.977",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.973 103.87H310.94V142.427H302.973V103.87Z",
    fill: "#E0CEAB",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.374 105.927H302.973V142.427H299.374V105.927Z",
    fill: "#F5D7CA",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.029 103.87H308.885V142.427H305.029V103.87Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.406 103.87H299.374V142.427H291.406V103.87Z",
    fill: "#E0CEAB",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.463 103.87H297.319V142.427H293.463V103.87Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.461 103.87H295.261V142.427H293.461V103.87Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.029 103.87H306.829V142.427H305.029V103.87Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.538 97.6348H307.666V103.932H307.538V97.6348Z",
    stroke: "#615E66",
    strokeWidth: 0.0983687
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.995 101.75H306.123V103.936H305.995V101.75Z",
    stroke: "#615E66",
    strokeWidth: 0.0983687
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.515 109.277H251.873V123.11H227.515V109.277Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.515 118.297H251.873V123.107H227.515V118.297Z",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.459 120.103H248.565V123.111H246.459V120.103Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.549 120.103H244.655V123.111H242.549V120.103Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.038 120.103H240.144V123.111H238.038V120.103Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.129 120.103H236.235V123.111H234.129V120.103Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.919 120.103H232.025V123.111H229.919V120.103Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.459 112.285H248.565V116.796H246.459V112.285Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.549 112.285H244.655V116.796H242.549V112.285Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.038 112.285H240.144V116.796H238.038V112.285Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.129 112.285H236.235V116.796H234.129V112.285Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.925 116.495H247.06V118.3H232.925V116.495Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.919 112.285H232.025V116.796H229.919V112.285Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.692 103.281L251.398 109.277H227.984L239.69 103.281H239.692Z",
    fill: "#D7C6A2",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.776 110.18L253.528 109.427L239.546 102.06L226.014 109.427L226.615 110.18L239.546 103.263L252.778 110.18H252.776Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.616 119.552H246.008V120.553H249.017V119.552H248.409C248.361 119.101 247.976 118.751 247.514 118.751C247.051 118.751 246.667 119.101 246.618 119.552H246.616Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.615 119.553L246.912 119.585L246.882 119.852H246.615V119.551V119.553ZM246.008 119.553H245.706V119.252H246.008V119.553ZM246.008 120.554V120.856H245.706V120.554H246.008ZM249.016 120.554H249.317V120.856H249.016V120.554ZM249.016 119.553V119.252H249.317V119.553H249.016ZM248.408 119.553V119.855H248.141L248.111 119.588L248.408 119.555V119.553ZM246.615 119.855H246.008V119.254H246.615V119.855ZM246.309 119.553V120.554H245.708V119.553H246.309ZM246.008 120.255H249.016V120.856H246.008V120.255ZM248.714 120.554V119.553H249.315V120.554H248.714ZM249.016 119.855H248.408V119.254H249.016V119.855ZM248.109 119.585C248.077 119.284 247.821 119.051 247.511 119.051V118.451C248.13 118.451 248.638 118.918 248.707 119.521L248.109 119.588V119.585ZM247.511 119.051C247.2 119.051 246.944 119.286 246.912 119.585L246.314 119.519C246.383 118.918 246.891 118.448 247.511 118.448V119.049V119.051Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.705 119.552H242.097V120.553H245.105V119.552H244.498C244.449 119.101 244.065 118.751 243.602 118.751C243.14 118.751 242.755 119.101 242.707 119.552H242.705Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.705 119.553L243.002 119.585L242.972 119.852H242.705V119.551V119.553ZM242.097 119.553H241.796V119.252H242.097V119.553ZM242.097 120.554V120.856H241.796V120.554H242.097ZM245.106 120.554H245.407V120.856H245.106V120.554ZM245.106 119.553V119.252H245.407V119.553H245.106ZM244.498 119.553V119.855H244.231L244.201 119.588L244.498 119.555V119.553ZM242.705 119.855H242.097V119.254H242.705V119.855ZM242.399 119.553V120.554H241.798V119.553H242.399ZM242.097 120.255H245.106V120.856H242.097V120.255ZM244.804 120.554V119.553H245.405V120.554H244.804ZM245.106 119.855H244.498V119.254H245.106V119.855ZM244.201 119.585C244.169 119.284 243.913 119.051 243.603 119.051V118.451C244.222 118.451 244.731 118.918 244.8 119.521L244.201 119.588V119.585ZM243.603 119.051C243.292 119.051 243.036 119.286 243.004 119.585L242.406 119.519C242.475 118.918 242.984 118.448 243.603 118.448V119.049V119.051Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.196 119.552H237.588V120.553H240.597V119.552H239.989C239.941 119.101 239.556 118.751 239.094 118.751C238.631 118.751 238.247 119.101 238.198 119.552H238.196Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.196 119.553L238.493 119.585L238.463 119.852H238.196V119.551V119.553ZM237.588 119.553H237.287V119.252H237.588V119.553ZM237.588 120.554V120.856H237.287V120.554H237.588ZM240.594 120.554H240.896V120.856H240.594V120.554ZM240.594 119.553V119.252H240.896V119.553H240.594ZM239.986 119.553V119.855H239.719L239.689 119.588L239.986 119.555V119.553ZM238.196 119.855H237.588V119.254H238.196V119.855ZM237.887 119.553V120.554H237.287V119.553H237.887ZM237.588 120.255H240.596V120.856H237.588V120.255ZM240.295 120.554V119.553H240.896V120.554H240.295ZM240.594 119.855H239.986V119.254H240.594V119.855ZM239.689 119.585C239.657 119.284 239.402 119.051 239.091 119.051V118.451C239.71 118.451 240.219 118.918 240.288 119.521L239.689 119.588V119.585ZM239.091 119.051C238.78 119.051 238.525 119.286 238.493 119.585L237.894 119.519C237.963 118.918 238.472 118.448 239.091 118.448V119.049V119.051Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.285 119.552H233.677V120.553H236.686V119.552H236.078C236.03 119.101 235.645 118.751 235.183 118.751C234.72 118.751 234.336 119.101 234.287 119.552H234.285Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.284 119.553L234.581 119.585L234.551 119.852H234.284V119.551V119.553ZM233.677 119.553H233.375V119.252H233.677V119.553ZM233.677 120.554V120.856H233.375V120.554H233.677ZM236.685 120.554H236.986V120.856H236.685V120.554ZM236.685 119.553V119.252H236.986V119.553H236.685ZM236.077 119.553V119.855H235.81L235.78 119.588L236.077 119.555V119.553ZM234.284 119.855H233.677V119.254H234.284V119.855ZM233.978 119.553V120.554H233.377V119.553H233.978ZM233.677 120.255H236.685V120.856H233.677V120.255ZM236.383 120.554V119.553H236.984V120.554H236.383ZM236.685 119.855H236.077V119.254H236.685V119.855ZM235.778 119.585C235.746 119.284 235.49 119.051 235.18 119.051V118.451C235.799 118.451 236.307 118.918 236.376 119.521L235.778 119.588V119.585ZM235.18 119.051C234.869 119.051 234.613 119.286 234.581 119.585L233.983 119.519C234.052 118.918 234.56 118.448 235.18 118.448V119.049V119.051Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.076 119.552H229.468V120.553H232.477V119.552H231.869C231.821 119.101 231.436 118.751 230.974 118.751C230.511 118.751 230.127 119.101 230.078 119.552H230.076Z",
    fill: "#E8CD9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.076 119.553L230.372 119.585L230.343 119.852H230.076V119.551V119.553ZM229.468 119.553H229.166V119.252H229.468V119.553ZM229.468 120.554V120.856H229.166V120.554H229.468ZM232.474 120.554H232.775V120.856H232.474V120.554ZM232.474 119.553V119.252H232.775V119.553H232.474ZM231.869 119.553V119.855H231.602L231.572 119.588L231.869 119.555V119.553ZM230.076 119.855H229.468V119.254H230.076V119.855ZM229.769 119.553V120.554H229.169V119.553H229.769ZM229.468 120.255H232.476V120.856H229.468V120.255ZM232.175 120.554V119.553H232.775V120.554H232.175ZM232.474 119.855H231.866V119.254H232.474V119.855ZM231.569 119.585C231.537 119.284 231.282 119.051 230.971 119.051V118.451C231.59 118.451 232.099 118.918 232.168 119.521L231.569 119.588V119.585ZM230.971 119.051C230.66 119.051 230.405 119.286 230.372 119.585L229.774 119.519C229.843 118.918 230.352 118.448 230.971 118.448V119.049V119.051Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.158 110.93C246.158 110.957 246.174 111.001 246.229 111.054C246.286 111.109 246.376 111.164 246.503 111.215C246.751 111.316 247.11 111.381 247.511 111.381C247.911 111.381 248.268 111.316 248.519 111.215C248.646 111.164 248.735 111.109 248.793 111.054C248.85 110.999 248.864 110.957 248.864 110.93C248.864 110.902 248.848 110.858 248.793 110.805C248.735 110.75 248.646 110.695 248.519 110.644C248.27 110.543 247.911 110.479 247.511 110.479C247.11 110.479 246.754 110.543 246.503 110.644C246.376 110.695 246.286 110.75 246.229 110.805C246.171 110.861 246.158 110.902 246.158 110.93Z",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.249 110.93C242.249 110.957 242.265 111.001 242.321 111.054C242.378 111.109 242.468 111.164 242.595 111.215C242.843 111.316 243.202 111.381 243.603 111.381C244.003 111.381 244.36 111.316 244.611 111.215C244.737 111.164 244.827 111.109 244.885 111.054C244.942 110.999 244.956 110.957 244.956 110.93C244.956 110.902 244.94 110.858 244.885 110.805C244.827 110.75 244.737 110.695 244.611 110.644C244.362 110.543 244.003 110.479 243.603 110.479C243.202 110.479 242.845 110.543 242.595 110.644C242.468 110.695 242.378 110.75 242.321 110.805C242.263 110.861 242.249 110.902 242.249 110.93Z",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.738 110.93C237.738 110.957 237.754 111.001 237.809 111.054C237.866 111.109 237.956 111.164 238.083 111.215C238.331 111.316 238.69 111.381 239.091 111.381C239.491 111.381 239.848 111.316 240.099 111.215C240.226 111.164 240.315 111.109 240.373 111.054C240.431 110.999 240.444 110.957 240.444 110.93C240.444 110.902 240.428 110.858 240.373 110.805C240.315 110.75 240.226 110.695 240.099 110.644C239.851 110.543 239.491 110.479 239.091 110.479C238.69 110.479 238.334 110.543 238.083 110.644C237.956 110.695 237.866 110.75 237.809 110.805C237.751 110.861 237.738 110.902 237.738 110.93Z",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.827 110.93C233.827 110.957 233.844 111.001 233.899 111.054C233.956 111.109 234.046 111.164 234.173 111.215C234.421 111.316 234.78 111.381 235.181 111.381C235.581 111.381 235.938 111.316 236.189 111.215C236.316 111.164 236.405 111.109 236.463 111.054C236.52 110.999 236.534 110.957 236.534 110.93C236.534 110.902 236.518 110.858 236.463 110.805C236.405 110.75 236.316 110.695 236.189 110.644C235.94 110.543 235.581 110.479 235.181 110.479C234.78 110.479 234.424 110.543 234.173 110.644C234.046 110.695 233.956 110.75 233.899 110.805C233.841 110.861 233.827 110.902 233.827 110.93Z",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.618 110.93C229.618 110.957 229.635 111.001 229.69 111.054C229.747 111.109 229.837 111.164 229.964 111.215C230.212 111.316 230.571 111.381 230.972 111.381C231.372 111.381 231.729 111.316 231.98 111.215C232.107 111.164 232.196 111.109 232.254 111.054C232.311 110.999 232.325 110.957 232.325 110.93C232.325 110.902 232.309 110.858 232.254 110.805C232.196 110.75 232.107 110.695 231.98 110.644C231.731 110.543 231.372 110.479 230.972 110.479C230.571 110.479 230.215 110.543 229.964 110.644C229.837 110.695 229.747 110.75 229.69 110.805C229.632 110.861 229.618 110.902 229.618 110.93Z",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.542 105.218L243.603 107.172H235.784L239.542 105.218Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.230165
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.482 117.021H318.569V142.793H307.482V117.021Z",
    fill: "#D8D1C3",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.18 116.419H318.868V116.719H307.18V116.419Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.555 117.021H318.493V118.221H307.555V117.021Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.555 131.705H318.493V132.905H307.555V131.705Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.801 117.021H317.37V129.907H312.801V117.021Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.473 140.395H317.37V142.791H313.473V140.395Z",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.473 140.395H315.571V142.791H313.473V140.395Z",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.828 140.395H312.725V142.791H308.828V140.395Z",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.679 140.395H310.777V142.791H308.679V140.395Z",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.797 133.8H317.37V134.699H315.797V133.8Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.549 133.8H315.122V134.699H313.549V133.8Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68 133.8H312.501V135.598H308.68V133.8Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.928 133.8H312.501V134.699H310.928V133.8Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68 133.8H310.253V134.699H308.68V133.8Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.801 118.818H317.37V121.816H312.801V118.818Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.801 123.014H317.37V126.011H312.801V123.014Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.801 126.907H317.37V129.905H312.801V126.907Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.875 118.818H313.774V121.816H312.875V118.818Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.875 123.014H313.774V126.011H312.875V123.014Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.875 126.907H313.774V129.905H312.875V126.907Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.555 130.505H318.493V130.805H307.555V130.505Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.679 118.818H310.626V121.816H308.679V118.818Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.679 123.014H310.626V126.011H308.679V123.014Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.679 126.907H310.626V129.905H308.679V126.907Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68 118.818H309.278V121.816H308.68V118.818Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68 123.014H309.278V126.011H308.68V123.014Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.68 126.907H309.278V129.905H308.68V126.907Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.299 118.818H316.246V121.816H314.299V118.818Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.299 123.014H316.246V126.011H314.299V123.014Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.299 126.907H316.246V129.905H314.299V126.907Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.229362
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.469 136.801C341.604 136.801 329.553 124.75 329.553 109.885C329.553 95.0196 341.604 82.9688 356.469 82.9688C371.334 82.9688 383.385 95.0196 383.385 109.885C383.385 124.75 371.334 136.801 356.469 136.801ZM356.469 134.523C342.862 134.523 331.831 123.492 331.831 109.885C331.831 96.2774 342.862 85.2468 356.469 85.2468C370.076 85.2468 381.107 96.2774 381.107 109.885C381.107 123.492 370.076 134.523 356.469 134.523Z",
    fill: "#F2C2AC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.469 124.269C348.525 124.269 342.086 117.893 342.086 110.028C342.086 102.163 348.525 95.7861 356.469 95.7861C364.413 95.7861 370.853 102.163 370.853 110.028C370.853 117.893 364.413 124.269 356.469 124.269ZM356.469 122.277C349.626 122.277 344.078 116.794 344.078 110.03C344.078 103.266 349.626 97.783 356.469 97.783C363.312 97.783 368.86 103.266 368.86 110.03C368.86 116.794 363.312 122.277 356.469 122.277Z",
    fill: "#F2C2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.469 136.801C341.604 136.801 329.553 124.75 329.553 109.885C329.553 95.0194 341.604 82.9688 356.469 82.9688C371.334 82.9688 383.385 95.0194 383.385 109.885C383.385 124.75 371.334 136.801 356.469 136.801Z",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.186 134.522V136.801",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.168 134.097L361.596 136.233",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.469 134.524C342.861 134.524 331.831 123.493 331.831 109.886C331.831 96.2788 342.861 85.248 356.469 85.248C370.076 85.248 381.106 96.2788 381.106 109.886C381.106 123.493 370.076 134.524 356.469 134.524Z",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.468 131.677C344.435 131.677 334.679 121.985 334.679 110.03C334.679 98.0745 344.435 88.3828 356.468 88.3828C368.502 88.3828 378.257 98.0745 378.257 110.03C378.257 121.985 368.502 131.677 356.468 131.677Z",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.469 128.827C346.165 128.827 337.813 120.411 337.813 110.029C337.813 99.6475 346.165 91.2314 356.469 91.2314C366.772 91.2314 375.125 99.6475 375.125 110.029C375.125 120.411 366.772 128.827 356.469 128.827Z",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.469 126.549C347.423 126.549 340.091 119.153 340.091 110.029C340.091 100.906 347.423 93.5098 356.469 93.5098C365.514 93.5098 372.847 100.906 372.847 110.029C372.847 119.153 365.514 126.549 356.469 126.549Z",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.469 124.272C348.525 124.272 342.086 117.896 342.086 110.031C342.086 102.165 348.525 95.7891 356.469 95.7891C364.413 95.7891 370.853 102.165 370.853 110.031C370.853 117.896 364.413 124.272 356.469 124.272Z",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.468 122.277C349.625 122.277 344.078 116.794 344.078 110.03C344.078 103.266 349.625 97.7832 356.468 97.7832C363.312 97.7832 368.859 103.266 368.859 110.03C368.859 116.794 363.312 122.277 356.468 122.277Z",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.468 117.721C352.142 117.721 348.636 114.277 348.636 110.03C348.636 105.782 352.142 102.339 356.468 102.339C360.794 102.339 364.301 105.782 364.301 110.03C364.301 114.277 360.794 117.721 356.468 117.721Z",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.807 138.651H341.23C341.572 138.082 341.372 137.37 341.23 137.084H339.807C339.464 137.768 339.665 138.414 339.807 138.651Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.358 140.362H347.781C348.123 139.793 347.923 139.08 347.781 138.795H346.358C346.015 139.479 346.216 140.125 346.358 140.362Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.341 141.502H353.764C354.107 140.933 353.906 140.22 353.764 139.935H352.341C351.999 140.619 352.199 141.264 352.341 141.502Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.605 141.502H360.028C360.37 140.933 360.17 140.22 360.028 139.935H358.605C358.262 140.619 358.463 141.264 358.605 141.502Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.301 140.647H365.724C366.067 140.078 365.866 139.366 365.724 139.08H364.301C363.959 139.765 364.159 140.41 364.301 140.647Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.68 134.951H336.103C336.446 134.382 336.245 133.669 336.103 133.384H334.68C334.338 134.068 334.538 134.714 334.68 134.951Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.124 129.823H331.548C331.89 129.254 331.689 128.541 331.548 128.256H330.124C329.782 128.94 329.982 129.586 330.124 129.823Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.988 124.127H328.412C328.754 123.558 328.554 122.845 328.412 122.56H326.988C326.646 123.244 326.847 123.889 326.988 124.127Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.711 117.863H326.135C326.477 117.294 326.276 116.581 326.135 116.296H324.711C324.369 116.98 324.569 117.626 324.711 117.863Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.143 111.311H325.566C325.908 110.742 325.708 110.029 325.566 109.743H324.143C323.8 110.428 324.001 111.073 324.143 111.311Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.996 104.759H326.42C326.762 104.19 326.561 103.477 326.42 103.191H324.996C324.654 103.876 324.854 104.521 324.996 104.759Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.275 98.4932H328.698C329.04 97.9242 328.84 97.2114 328.698 96.9258H327.275C326.932 97.6103 327.133 98.2556 327.275 98.4932Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.407 92.5117H331.831C332.173 91.9428 331.973 91.2299 331.831 90.9443H330.407C330.065 91.6288 330.266 92.2741 330.407 92.5117Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.965 87.9561H336.388C336.731 87.3871 336.53 86.6742 336.388 86.3887H334.965C334.623 87.0732 334.823 87.7184 334.965 87.9561Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.376 83.9688H341.8C342.142 83.3998 341.941 82.6869 341.8 82.4014H340.376C340.034 83.0859 340.234 83.7311 340.376 83.9688Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.358 81.6875H347.781C348.123 81.1185 347.923 80.4057 347.781 80.1201H346.358C346.015 80.8046 346.216 81.4499 346.358 81.6875Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.909 80.2647H354.333C354.675 79.6957 354.474 78.9828 354.333 78.6973H352.909C352.567 79.3818 352.768 80.027 352.909 80.2647Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.459 80.5498H360.883C361.225 79.9808 361.024 79.268 360.883 78.9824H359.459C359.117 79.6669 359.317 80.3122 359.459 80.5498Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.01 81.9746H367.433C367.776 81.4056 367.575 80.6928 367.433 80.4072H366.01C365.668 81.0917 365.868 81.737 366.01 81.9746Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.707 84.5361H373.131C373.473 83.9672 373.272 83.2543 373.131 82.9688H371.707C371.365 83.6533 371.565 84.2985 371.707 84.5361Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.137 138.938H372.56C372.903 138.369 372.702 137.656 372.56 137.37H371.137C370.795 138.055 370.995 138.7 371.137 138.938Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.248 92.6553L356.754 109.888",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.834 87.9551L356.754 109.885",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.707 84.3955L356.755 109.744",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.011 81.9736L356.611 109.744",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.887 80.5508L356.61 109.745",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.763 80.2637L356.469 109.316",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.64 81.6885L356.469 109.745",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.8 83.9668L356.469 109.886",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.531 87.3848L356.469 109.886",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.975 91.8018L356.469 109.889",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.842 97.2119L356.186 109.886",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.42 103.193L356.327 109.886",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.996 109.743L356.612 110.029",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.565 116.294L356.183 110.029",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.702 122.418L356.469 110.027",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.835 128.258L356.61 109.888",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.248 133.383L356.324 110.027",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.52 137.088L356.612 109.887",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.927 138.653L356.61 109.887",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.667 97.9238L356.611 110.029",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.375 104.048L356.754 110.03",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.944 110.457L356.469 109.888",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.518 116.864L356.611 110.027",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.094 123.131L356.183 109.888",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.819 128.827L356.754 110.029",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.262 133.668L356.328 109.743",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.851 137.37L356.471 109.741",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.441 139.08L356.469 109.601",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.317 139.933L356.468 109.743",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.909 139.792L356.612 109.743",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.279 90.2336L372.561 88.3828",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.556 126.691L376.123 128.259",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.569 130.109L371.851 131.96",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.723 87.384L367.72 85.5332",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.881 85.819L362.45 83.6826",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.755 82.9688V85.2468",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.057 83.541L351.484 85.6774",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.645 85.25L346.642 87.2447",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.803 88.0986L342.085 89.8077",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.675 91.6562L338.384 93.2236",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.257 96.3564L335.107 97.3527",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.978 101.343L332.973 102.056",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.697 106.895L331.975 107.18",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.697 112.59L331.833 112.305",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.693 117.863L332.829 117.294",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.113 122.987L334.964 121.847",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.39 127.546L337.957 126.265",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.52 131.391L341.802 129.682",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.504 134.238L346.358 132.387",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.63 133.954L350.061 135.949",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.564 83.2549L365.727 84.5367",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.714 86.3881L367.292 81.832",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.868 80.5508L360.314 83.2561",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.301 84.1092L361.024 80.1221",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.174 79.5518L354.901 82.9699",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.746 83.1136L354.473 79.5537",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.207 83.9689L352.625 79.8379",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.05 83.1129L347.923 80.2637",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.216 81.4053L343.794 86.1053",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.64 84.3951L342.085 83.1133",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.52 83.9668L339.238 89.2358",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.513 86.6742L336.389 86.3887",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.957 90.375L331.834 90.944",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.393 93.0823V87.9551",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.252 94.6484L328.128 96.7848",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.261 98.0653L331.548 92.5107",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.689 99.2061L325.708 103.193",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.267 103.48L328.272 98.4971",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.123 104.475L325.14 109.744",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.42 104.617L329.553 109.032",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.553 110.599L325.566 116.153",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.979 114.727L325.707 110.882",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.123 116.01L327.701 122.419",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.547 119.999L326.278 116.723",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.975 121.278L330.834 128.115",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.111 124.981L328.557 123.13",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.966 126.122L335.107 133.242",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.548 128.4L337.957 129.397",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.811 130.25L340.234 137.086",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.228 132.672L336.104 133.385",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.231 137.088L347.924 135.664",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.367 133.241L346.216 138.937",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.3 135.664L371.137 137.373",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.57 133.527L365.725 138.938",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.852 87.1016H376.976",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.128 89.5205L373.132 84.5371",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.697 129.682L381.106 128.827",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.142 133.101L376.551 133.67",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.701 130.536L371.85 137.372",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.423 142.498L357.039 109.601L356.47 111.451L369.003 142.496H371.425L371.423 142.498Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.371 143.07L356.041 109.034L356.61 110.885L344.363 143.07H342.369H342.371Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.612 112.593C355.196 112.593 354.049 111.445 354.049 110.029C354.049 108.614 355.196 107.466 356.612 107.466C358.028 107.466 359.176 108.614 359.176 110.029C359.176 111.445 358.028 112.593 356.612 112.593Z",
    fill: "#E8E1F3",
    stroke: "#E8E1F3",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.732 135.806L360.029 139.793",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.745 136.66L364.159 139.224",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.893 136.802L353.905 139.934",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.904 136.802L358.604 140.078",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.481 136.518L347.925 138.94",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.922 135.806L352.198 139.937",
    stroke: "#615E66",
    strokeWidth: 0.217996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.256 135.454H319.108V141.88H306.256V135.454Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.256 139.308H319.108V141.879H306.256V139.308Z",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.285 140.373H317.312V141.88H316.285V140.373Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2 140.373H315.227V141.88H314.2V140.373Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.793 140.373H312.82V141.88H311.793V140.373Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.708 140.373H310.735V141.88H309.708V140.373Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.461 140.373H308.488V141.88H307.461V140.373Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.285 136.201H317.312V138.511H316.285V136.201Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2 136.201H315.227V138.511H314.2V136.201Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.793 136.201H312.82V138.511H311.793V136.201Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.708 136.201H310.735V138.511H309.708V136.201Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.461 136.201H308.488V138.511H307.461V136.201Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.629 132.176L318.726 135.451H306.63L312.629 132.176Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.366 135.839L320.01 135.401L312.55 131.47L305.331 135.401L305.872 135.969L312.683 132.241L319.366 135.839Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.653 135.839L389.296 135.401L381.836 131.47L374.617 135.401L375.158 135.969L381.969 132.241L388.653 135.839Z",
    fill: "#DCD4AF",
    stroke: "#908E94",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.241 119.399L244.75 134.693V135.978L257.988 133.406L311.198 122.61L314.283 123.638L301.945 131.351L295.776 136.749C299.118 135.079 306.392 131.506 308.757 130.579C311.713 129.423 323.665 123.638 325.336 122.867C328.548 121.384 327.521 119.397 325.336 119.011C319.577 117.778 311.54 118.753 308.241 119.397V119.399Z",
    fill: "#FAEAC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.832 142.919H252.848L253.753 139.675C254.073 138.528 253.21 137.393 252.019 137.393H244.75V135.978L309.669 122.994C311.798 122.569 313.956 122.307 316.126 122.215C316.89 122.183 317.202 123.181 316.557 123.59L295.723 136.838C294.619 137.538 294.141 138.904 294.564 140.139L295.514 142.917H292.301V139.187C292.301 138.638 291.743 138.264 291.235 138.475L288.575 139.577V137.391L303.098 127.237C303.635 126.944 303.281 126.053 302.689 126.208C292.071 128.982 275.41 132.555 270.196 133.793C265.449 134.92 260.812 136.146 258.097 137.015C257.024 137.357 256.389 138.41 256.497 139.529L256.83 142.917L256.832 142.919Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.848 134.308V137.65",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.061 133.794V137.007",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.543 132.125V135.082",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.76 133.151V136.622",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.46 132.638V135.85",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.977 137.65L259.016 136.493",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.075 142.92V139.4C293.075 138.619 293.427 137.881 294.041 137.397C295.391 136.333 297.163 134.958 298.832 133.689C299.882 132.845 301.155 131.895 302.688 130.834C302.898 130.687 303.083 130.559 303.247 130.451C306.129 128.489 309.865 126.174 314.667 123.51C308.757 126.787 305.184 129.162 303.248 130.449H303.247C303.056 130.581 302.871 130.706 302.688 130.832C301.738 131.501 300.325 132.552 298.832 133.687C295.965 135.985 294.755 137.48 294.488 138.161V142.916H293.073L293.075 142.92Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.307 139.021L254.519 142.791H256.832C256.748 142.449 256.781 141.351 256.574 139.706C256.368 138.061 257.261 137.392 257.859 137.265L268.141 134.308L257.422 136.849C256.356 137.103 255.53 137.949 255.307 139.021Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.577 138.292L309.783 125.954L314.796 123.513",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.241 119.399L244.75 134.693V133.922L308.241 117.598C311.969 116.87 320.606 115.851 325.336 117.598C327.187 118.216 328.119 118.799 328.42 119.013C328.42 120.042 328.548 121.199 327.907 121.712C327.393 122.123 306.272 131.909 295.776 136.749C299.118 135.079 306.392 131.506 308.757 130.579C311.713 129.422 323.665 123.638 325.336 122.867C328.548 121.384 327.521 119.397 325.336 119.011C319.577 117.777 311.54 118.753 308.241 119.397V119.399Z",
    fill: "#FBDC99",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.75 132.638V133.922L262.871 129.295C277.221 125.311 307.804 117.214 315.31 116.7C322.815 116.187 327.177 118.028 328.418 119.014V116.478C328.418 115.868 328.245 115.256 327.771 114.876C326.547 113.902 324.185 112.948 321.993 112.844C315.208 112.226 307.513 113.958 304.513 114.9L244.75 132.636V132.638Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.75 134.566V135.981",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.715 126.212L314.667 123.513",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.595 118.5L314.795 122.228",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.811 119.014L313.51 122.356",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.994 118.5L315.824 122.228",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.896 118.628V122.356",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.187 128.92C339.483 128.92 338.102 130.301 338.102 132.005V135.861C338.102 137.565 339.483 138.946 341.187 138.946C342.89 138.946 344.271 137.565 344.271 135.861V132.005C344.271 130.301 342.89 128.92 341.187 128.92Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.802 129.818C339.381 129.818 338.23 130.969 338.23 132.39V135.988C338.23 137.408 339.381 138.559 340.802 138.559C342.222 138.559 343.373 137.408 343.373 135.988V132.39C343.373 130.969 342.222 129.818 340.802 129.818Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.316 132.391V141.901",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.389 133.162L341.189 134.962",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.987 135.218L341.187 137.018",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.987 133.162L341.187 134.962",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.794 128.92C325.09 128.92 323.709 130.301 323.709 132.005C323.709 133.709 325.09 135.09 326.794 135.09C328.498 135.09 329.879 133.709 329.879 132.005C329.879 130.301 328.498 128.92 326.794 128.92Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.794 130.077H326.536C325.187 130.077 324.095 131.171 324.095 132.519C324.095 133.868 325.188 134.96 326.536 134.96H326.794C328.143 134.96 329.235 133.866 329.235 132.519C329.235 131.169 328.141 130.077 326.794 130.077Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.922 132.391V141.901",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.124 132.646L326.924 134.447",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.592 132.646L326.792 134.447",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.075 136.908C337.075 135.81 336.849 134.726 336.412 133.721L335.973 132.714C335.122 130.758 332.348 130.758 331.496 132.714L331.057 133.721C330.618 134.726 330.394 135.81 330.394 136.908C330.394 137.182 330.616 137.404 330.89 137.404H336.581C336.855 137.404 337.077 137.182 337.077 136.908H337.075Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.176 136.783C336.176 135.888 335.989 135.002 335.625 134.184L335.416 133.716C334.62 131.922 332.074 131.922 331.277 133.716L331.068 134.184C330.706 135.002 330.518 135.888 330.518 136.783C330.518 137.054 330.738 137.277 331.011 137.277H335.68C335.951 137.277 336.174 137.056 336.174 136.783H336.176Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.733 135.476V141.773",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.063 134.96L333.733 136.502",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.02 135.731L333.735 137.146",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.053 141.756C352.248 140.68 352.078 138.76 350.713 137.91L348.449 136.501C348.098 136.285 347.654 136.293 347.315 136.525L345.307 137.896C344.006 138.785 343.833 140.637 344.947 141.75C344.96 141.764 344.98 141.772 345 141.772H351.01C351.026 141.772 351.044 141.766 351.055 141.754L351.053 141.756Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.055 141.754C351.044 141.766 351.026 141.772 351.01 141.772H345C344.98 141.772 344.96 141.764 344.947 141.75C343.833 140.637 344.006 138.785 345.307 137.896L347.315 136.525C347.654 136.293 348.098 136.285 348.449 136.501L350.713 137.91C352.078 138.76 352.248 140.68 351.053 141.756L351.055 141.754ZM351.055 141.754L351.142 141.851",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.872 141.59C351.655 140.652 351.404 139.235 350.347 138.621L347.811 137.152C347.532 136.99 347.186 136.994 346.908 137.161L345.171 138.222C343.935 138.975 343.849 140.736 345.002 141.61C345.029 141.631 345.063 141.641 345.098 141.641H350.758C350.804 141.641 350.847 141.621 350.874 141.586L350.872 141.59Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.258 139.589V141.645",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.586 139.074L348.256 140.617",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.542 139.846L348.257 141.26",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.993 141.901H322.479C321.818 141.901 321.183 141.651 320.701 141.2L320.353 140.876C320.239 140.77 320.156 140.636 320.111 140.486L320.079 140.376C319.837 139.56 320.827 138.944 321.452 139.524V139.087C321.452 138.188 322.582 137.785 323.15 138.484C322.879 137.398 324.126 136.573 325.017 137.25L325.271 137.443L325.34 137.228C325.58 136.483 326.391 136.083 327.126 136.349C327.862 136.614 328.232 137.435 327.945 138.161L327.817 138.484C328.911 138.484 329.521 139.745 328.842 140.602L328.328 141.252C328.004 141.661 327.51 141.901 326.989 141.901H326.993Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.509 141.774L327.052 139.332",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.022 140.743L325.123 138.815",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.324 141.901L322.04 140.23",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.451 139.846L322.552 140.745",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.223 141.773L326.794 137.531",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.553 128.92C145.849 128.92 144.468 130.301 144.468 132.005V135.861C144.468 137.565 145.849 138.946 147.553 138.946C149.257 138.946 150.638 137.565 150.638 135.861V132.005C150.638 130.301 149.257 128.92 147.553 128.92Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.167 129.818C145.746 129.818 144.596 130.969 144.596 132.39V135.988C144.596 137.408 145.746 138.559 147.167 138.559C148.587 138.559 149.738 137.408 149.738 135.988V132.39C149.738 130.969 148.587 129.818 147.167 129.818Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.682 132.391V141.901",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.754 133.162L147.554 134.962",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.353 135.218L147.552 137.018",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.353 133.162L147.552 134.962",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.159 128.92C131.456 128.92 130.074 130.301 130.074 132.005C130.074 133.709 131.456 135.09 133.159 135.09C134.863 135.09 136.244 133.709 136.244 132.005C136.244 130.301 134.863 128.92 133.159 128.92Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.159 130.077H132.901C131.552 130.077 130.46 131.171 130.46 132.519C130.46 133.868 131.554 134.96 132.901 134.96H133.159C134.509 134.96 135.601 133.866 135.601 132.519C135.601 131.169 134.507 130.077 133.159 130.077Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.286 132.391V141.901",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.488 132.646L133.288 134.447",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.957 132.646L133.157 134.447",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.44 136.908C143.44 135.81 143.214 134.726 142.777 133.721L142.339 132.714C141.487 130.758 138.713 130.758 137.861 132.714L137.422 133.721C136.984 134.726 136.759 135.81 136.759 136.908C136.759 137.182 136.982 137.404 137.255 137.404H142.947C143.22 137.404 143.442 137.182 143.442 136.908H143.44Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.541 136.783C142.541 135.888 142.354 135.002 141.99 134.184L141.782 133.716C140.985 131.922 138.439 131.922 137.642 133.716L137.434 134.184C137.072 135.002 136.883 135.888 136.883 136.783C136.883 137.054 137.103 137.277 137.377 137.277H142.045C142.317 137.277 142.539 137.056 142.539 136.783H142.541Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.098 135.476V141.773",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.427 134.96L140.098 136.502",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.384 135.731L140.099 137.146",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.418 141.756C158.612 140.68 158.443 138.76 157.077 137.91L154.813 136.501C154.463 136.285 154.018 136.293 153.68 136.525L151.671 137.896C150.371 138.785 150.197 140.637 151.311 141.75C151.325 141.764 151.344 141.772 151.364 141.772H157.374C157.39 141.772 157.408 141.766 157.42 141.754L157.418 141.756Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.42 141.754C157.408 141.766 157.39 141.772 157.374 141.772H151.364C151.344 141.772 151.325 141.764 151.311 141.75C150.197 140.637 150.371 138.785 151.671 137.896L153.68 136.525C154.018 136.293 154.463 136.285 154.813 136.501L157.077 137.91C158.443 138.76 158.612 140.68 157.418 141.756L157.42 141.754ZM157.42 141.754L157.506 141.851",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.238 141.59C158.021 140.652 157.769 139.235 156.712 138.621L154.176 137.152C153.897 136.99 153.551 136.994 153.273 137.161L151.536 138.222C150.301 138.975 150.214 140.736 151.367 141.61C151.395 141.631 151.428 141.641 151.463 141.641H157.124C157.169 141.641 157.212 141.621 157.24 141.586L157.238 141.59Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.622 139.589V141.645",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.951 139.074L154.621 140.617",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.907 139.846L154.623 141.26",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.358 141.901H128.845C128.184 141.901 127.548 141.651 127.066 141.2L126.718 140.876C126.604 140.77 126.521 140.636 126.476 140.486L126.444 140.376C126.203 139.56 127.192 138.944 127.818 139.524V139.087C127.818 138.188 128.947 137.785 129.516 138.484C129.244 137.398 130.491 136.573 131.383 137.25L131.636 137.443L131.705 137.228C131.945 136.483 132.756 136.083 133.492 136.349C134.227 136.614 134.597 137.435 134.31 138.161L134.182 138.484C135.276 138.484 135.886 139.745 135.207 140.602L134.694 141.252C134.369 141.661 133.875 141.901 133.354 141.901H133.358Z",
    fill: "#E9A59B",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.874 141.774L133.416 139.332",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.388 140.743L131.489 138.815",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.688 141.901L128.404 140.23",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.815 139.846L128.916 140.745",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.587 141.773L133.158 137.531",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.676 128.141C250.972 128.141 249.591 129.522 249.591 131.225V135.082C249.591 136.785 250.972 138.166 252.676 138.166C254.38 138.166 255.761 136.785 255.761 135.082V131.225C255.761 129.522 254.38 128.141 252.676 128.141Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.29 129.039C250.87 129.039 249.719 130.19 249.719 131.61V135.209C249.719 136.629 250.87 137.78 252.29 137.78C253.71 137.78 254.861 136.629 254.861 135.209V131.61C254.861 130.19 253.71 129.039 252.29 129.039Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.805 131.609V142.92",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.877 132.381L252.805 134.525",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.476 134.438L252.805 136.109",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.476 132.381L252.805 134.051",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.423 132.766C241.719 132.766 240.338 134.147 240.338 135.85C240.338 137.554 241.719 138.935 243.423 138.935C245.127 138.935 246.508 137.554 246.508 135.85C246.508 134.147 245.127 132.766 243.423 132.766Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.423 133.924H243.165C241.815 133.924 240.724 135.018 240.724 136.365C240.724 137.715 241.817 138.807 243.165 138.807H243.423C244.772 138.807 245.864 137.713 245.864 136.365C245.864 135.016 244.77 133.924 243.423 133.924Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.55 136.236V142.792",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.753 136.494L243.553 138.294",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.222 136.494L243.422 138.294",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.976 142.793C260.976 142.793 261.021 142.737 261.043 142.71C261.896 141.606 261.641 139.958 260.403 139.186L258.139 137.778C257.789 137.561 257.344 137.569 257.006 137.801L254.995 139.173C253.82 139.975 253.567 141.563 254.348 142.684C254.373 142.72 254.426 142.793 254.426 142.793H260.974H260.976Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.569 142.641C261.34 141.714 261.092 140.317 260.049 139.711L257.549 138.261C257.272 138.102 256.929 138.106 256.66 138.271L254.946 139.318C253.726 140.062 253.64 141.799 254.779 142.66C254.804 142.68 254.838 142.692 254.873 142.692H260.455C260.5 142.692 260.541 142.672 260.571 142.639L260.569 142.641Z",
    fill: "#AACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.946 140.863V142.791",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.276 140.351L257.946 141.893",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23 141.122L257.946 142.537",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.912 142.792C243.912 142.792 243.627 142.597 243.499 142.477L243.153 142.152C243.037 142.046 242.954 141.912 242.911 141.763L242.877 141.652C242.635 140.836 243.625 140.22 244.251 140.801V140.364C244.251 139.465 245.382 139.061 245.95 139.76C245.679 138.674 246.924 137.85 247.82 138.526L248.073 138.719L248.14 138.505C248.382 137.759 249.191 137.36 249.929 137.625C250.664 137.891 251.034 138.711 250.745 139.437L250.617 139.76C251.709 139.76 252.321 141.021 251.642 141.879L251.131 142.528C251.054 142.626 250.871 142.792 250.871 142.792H243.912Z",
    fill: "#AACAC9",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.469 142.793L249.848 140.607",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.013 141.931L247.921 140.092",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.825 142.793L244.836 141.508",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.25 141.122L245.266 142.066",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.177 142.793L249.591 138.809",
    stroke: "#615E66",
    strokeWidth: 0.196737,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.273 128.92C371.977 128.92 373.358 130.301 373.358 132.005V135.861C373.358 137.565 371.977 138.946 370.273 138.946C368.57 138.946 367.188 137.565 367.188 135.861V132.005C367.188 130.301 368.57 128.92 370.273 128.92Z",
    fill: "#FFD6D0",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.658 129.818C372.079 129.818 373.23 130.969 373.23 132.39V135.988C373.23 137.408 372.079 138.559 370.658 138.559C369.238 138.559 368.087 137.408 368.087 135.988V132.39C368.087 130.969 369.238 129.818 370.658 129.818Z",
    fill: "#E9A59B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.144 132.391V141.901",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.071 133.162L370.271 134.962",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.473 135.218L370.273 137.018",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.473 133.162L370.273 134.962",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.385 136.908C374.385 135.81 374.611 134.726 375.048 133.721L375.487 132.714C376.338 130.758 379.112 130.758 379.964 132.714L380.403 133.721C380.842 134.726 381.066 135.81 381.066 136.908C381.066 137.182 380.844 137.404 380.57 137.404H374.879C374.605 137.404 374.383 137.182 374.383 136.908H374.385Z",
    fill: "#E1F1F1",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.407 141.756C359.212 140.68 359.382 138.76 360.747 137.91L363.011 136.501C363.362 136.285 363.806 136.293 364.145 136.525L366.153 137.896C367.454 138.785 367.627 140.637 366.513 141.75C366.5 141.764 366.48 141.772 366.46 141.772H360.45C360.434 141.772 360.416 141.766 360.405 141.754L360.407 141.756Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.405 141.754C360.416 141.766 360.434 141.772 360.45 141.772H366.46C366.48 141.772 366.5 141.764 366.513 141.75C367.627 140.637 367.454 138.785 366.153 137.896L364.145 136.525C363.806 136.293 363.362 136.285 363.011 136.501L360.747 137.91C359.382 138.76 359.212 140.68 360.407 141.756L360.405 141.754ZM360.405 141.754L360.318 141.851",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.588 141.59C359.805 140.652 360.056 139.235 361.113 138.621L363.649 137.152C363.928 136.99 364.274 136.994 364.552 137.161L366.289 138.222C367.525 138.975 367.611 140.736 366.458 141.61C366.431 141.631 366.397 141.641 366.362 141.641H360.702C360.656 141.641 360.613 141.621 360.586 141.586L360.588 141.59Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.202 139.589V141.645",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.874 139.074L363.204 140.617",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.918 139.846L363.203 141.26",
    stroke: "#615E66",
    strokeWidth: 0.196737
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1982 113.552H120.052V142.948H73.1982V113.552Z",
    fill: "#F7F5F0",
    stroke: "#615E66",
    strokeWidth: 0.182331
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8263 134.198H119.692V140.75H73.8263V134.198Z",
    fill: "#D9D9D9",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.602 134.198H113.346V140.75H109.602V134.198Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.98 134.198H118.724V140.75H114.98V134.198Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.719 134.198H108.463V140.75H104.719V134.198Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1024 134.198H102.846V140.75H99.1024V134.198Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4842 134.198H97.2275V140.75H93.4842V134.198Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.869 134.198H91.6123V140.75H87.869V134.198Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2517 134.198H85.9951V140.75H82.2517V134.198Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6336 134.198H80.377V140.75H76.6336V134.198Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3575 118.049H120.162V124.601H73.3575V118.049Z",
    fill: "#EFCDBD",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3575 118.049H120.162V118.984H73.3575V118.049Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3575 126.476H120.162V127.411H73.3575V126.476Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3575 134.198H120.162V135.133H73.3575V134.198Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3575 113.136H120.162V116.177H73.3575V113.136Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3575 113.136H120.162V114.071H73.3575V113.136Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1243 115.008H120.395V116.412H73.1243V115.008Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.949 118.049H119.692V122.261H115.949V118.049Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.737 118.049H115.48V122.261H111.737V118.049Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.527 118.049H111.271V122.261H107.527V118.049Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.314 118.049H107.058V122.261H103.314V118.049Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1024 118.049H102.846V122.261H99.1024V118.049Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8895 118.049H98.6328V122.261H94.8895V118.049Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 118.049H94.4199V122.261H90.6766V118.049Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4636 118.049H90.207V122.261H86.4636V118.049Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2517 118.049H85.9951V122.261H82.2517V118.049Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0388 118.049H81.7822V122.261H78.0388V118.049Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8269 118.049H77.5703V122.261H73.8269V118.049Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.949 126.476H119.692V130.219H115.949V126.476Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.737 126.476H115.48V130.219H111.737V126.476Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.527 126.476H111.271V130.219H107.527V126.476Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.314 126.476H107.058V130.219H103.314V126.476Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1024 126.476H102.846V130.219H99.1024V126.476Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8895 126.476H98.6328V130.219H94.8895V126.476Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6766 126.476H94.4199V130.219H90.6766V126.476Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4636 126.476H90.207V130.219H86.4636V126.476Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2517 126.476H85.9951V130.219H82.2517V126.476Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0388 126.476H81.7822V130.219H78.0388V126.476Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8269 126.476H77.5703V130.219H73.8269V126.476Z",
    fill: "#F3E3C0",
    stroke: "#615E66",
    strokeWidth: 0.358217
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3647 103.669H92.3779V113.174H73.3647V103.669Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3647 109.37H92.3779V113.174H73.3647V109.37Z",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2014 110.943H89.7207V113.173H88.2014V110.943Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1156 110.943H86.6348V113.173H85.1156V110.943Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5599 110.943H83.0791V113.173H81.5599V110.943Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.475 110.943H79.9941V113.173H78.475V110.943Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1507 110.943H76.6699V113.173H75.1507V110.943Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2014 104.772H89.7207V108.189H88.2014V104.772Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1156 104.772H86.6348V108.189H85.1156V104.772Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5599 104.772H83.0791V108.189H81.5599V104.772Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.475 104.772H79.9941V108.189H78.475V104.772Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1507 104.772H76.6699V108.189H75.1507V104.772Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7934 98.8203L91.8125 103.666H73.9227L82.7934 98.8203Z",
    fill: "#F8E7C3",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7593 104.238L93.7109 103.589L82.6749 97.7744L71.994 103.589L72.7973 104.43L82.8729 98.9153L92.7593 104.238Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.291033
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46637 101.086H62.1787V125.435H1.46637V101.086Z",
    fill: "#F4D7C9",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46637 117.969H62.1787V125.436H1.46637V117.969Z",
    fill: "#D7C7A3",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9573 105.956H59.2568V109.204H57.9573V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.317223 102.871H63.9658V103.845H-0.317223V102.871Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9573 112.772H59.2568V116.02H57.9573V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 119.591H60.8818V125.435H57.6341V119.591Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8416 119.591H54.7119V125.435H49.8416V119.591Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6991 119.591H47.5693V125.435H42.6991V119.591Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5575 119.591H40.4277V125.435H35.5575V119.591Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.934 120.726C33.934 119.56 32.9898 118.616 31.8244 118.616C30.659 118.616 29.7148 119.56 29.7148 120.726V125.435H33.9365V120.726H33.934Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2176 119.591H28.0879V125.435H23.2176V119.591Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0769 119.591H20.9473V125.435H16.0769V119.591Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61111 119.591H13.4814V125.435H8.61111V119.591Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09149 119.591H6.01367V125.435H3.09149V119.591Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6341 120.565H60.8818V125.436H57.6341V120.565Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8416 120.565H54.7119V125.436H49.8416V120.565Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6991 120.565H47.5693V125.436H42.6991V120.565Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5575 120.565H40.4277V125.436H35.5575V120.565Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.934 121.7C33.934 120.535 32.9898 119.591 31.8244 119.591C30.659 119.591 29.7148 120.535 29.7148 121.7V125.435H33.9365V121.7H33.934Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2176 120.565H28.0879V125.436H23.2176V120.565Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0769 120.565H20.9473V125.436H16.0769V120.565Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61111 120.565H13.4814V125.436H8.61111V120.565Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09149 120.565H6.01367V125.436H3.09149V120.565Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4377 105.956H53.7373V109.204H52.4377V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.4377 112.772H53.7373V116.02H52.4377V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8674 105.956H50.167V109.204H48.8674V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8674 112.772H50.167V116.02H48.8674V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2971 105.956H46.5967V109.204H45.2971V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2971 112.772H46.5967V116.02H45.2971V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.05 105.956H43.3496V109.204H42.05V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.05 112.772H43.3496V116.02H42.05V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1526 105.956H39.4521V109.204H38.1526V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1526 112.772H39.4521V116.02H38.1526V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9075 105.956H36.207V109.204H34.9075V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9075 112.772H36.207V116.02H34.9075V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.011 105.956H32.3105V109.204H31.011V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.011 112.772H32.3105V116.02H31.011V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1155 105.956H28.415V109.204H27.1155V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1155 112.772H28.415V116.02H27.1155V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5432 105.956H24.8428V109.204H23.5432V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5432 112.772H24.8428V116.02H23.5432V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2961 105.956H21.5957V109.204H20.2961V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2961 112.772H21.5957V116.02H20.2961V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4036 105.956H17.7031V109.204H16.4036V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4036 112.772H17.7031V116.02H16.4036V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8303 105.956H14.1299V109.204H12.8303V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8303 112.772H14.1299V116.02H12.8303V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58422 105.956H10.8838V109.204H9.58422V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58422 112.772H10.8838V116.02H9.58422V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38891 105.956H5.68848V109.204H4.38891V105.956Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.38891 112.772H5.68848V116.02H4.38891V112.772Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.4944 101.086H63.1523V103.034H0.4944V101.086Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.6599 101.733H62.1787V102.382H56.6599V101.733Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8698 101.733H54.3887V102.382H48.8698V101.733Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0778 101.733H46.5967V102.382H41.0778V101.733Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2849 101.733H38.8037V102.382H33.2849V101.733Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4929 101.733H31.0117V102.382H25.4929V101.733Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7019 101.733H23.2207V102.382H17.7019V101.733Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90981 101.733H15.4287V102.382H9.90981V101.733Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1169 101.733H7.63574V102.382H2.1169V101.733Z",
    fill: "#CDD9F4",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5858 99.6255L29.9038 99.6901L29.8516 99.9511H29.5858V99.6255ZM28.2539 99.6255H27.9283V99.3H28.2539V99.6255ZM28.2539 101.248V101.574H27.9283V101.248H28.2539ZM34.7468 101.248H35.0723V101.574H34.7468V101.248ZM34.7468 99.6255V99.3H35.0723V99.6255H34.7468ZM33.4149 99.6255V99.9511H33.149L33.0968 99.6901L33.4149 99.6255ZM29.5858 99.9511H28.2539V99.3025H29.5858V99.9511ZM28.5769 99.6255V101.248H27.9283V99.6255H28.5769ZM28.2539 100.923H34.7468V101.571H28.2539V100.923ZM34.4213 101.248V99.6255H35.0698V101.248H34.4213ZM34.7468 99.9511H33.4149V99.3025H34.7468V99.9511ZM33.0968 99.6901C32.9775 99.0988 32.4508 98.6515 31.8246 98.6515V98.0029C32.7664 98.0029 33.5516 98.6714 33.733 99.5609L33.0968 99.6901ZM31.8246 98.6515H31.176V98.0029H31.8246V98.6515ZM31.176 98.6515C30.5499 98.6515 30.0231 99.0988 29.9038 99.6901L29.2677 99.5609C29.4491 98.6714 30.2343 98.0029 31.176 98.0029V98.6515Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5851 99.6248H28.2532V101.247H34.7461V99.6248H33.4142C33.2651 98.8843 32.6091 98.3252 31.8239 98.3252H31.1753C30.3901 98.3252 29.7341 98.8818 29.5851 99.6248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.558 143.282V124.777H193.579L201.046 120.394L208.838 123.478L218.092 117.959L219.878 143.282H119.56H119.558Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.505 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.453 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.399 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.348 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.295 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.243 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.192 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.14 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.088 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.036 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.984 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.933 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.88 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.828 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.777 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.725 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.671 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.618 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.567 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.515 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.463 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.411 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.359 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.308 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.255 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.204 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.151 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.047 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.997 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.944 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.89 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.838 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.786 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.734 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.682 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.631 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.579 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.526 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.475 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.424 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.371 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.319 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.268 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.216 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.164 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.108 127.374V143.282",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.057 126.889V143.284",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.005 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.953 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.901 126.078V143.286",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.719 119.095C116.213 119.224 110.898 117.96 108.682 117.309C116.961 125.75 118.258 127.372 119.719 128.185C126.538 128.833 124.913 127.211 133.679 127.211C142.446 127.211 147.316 129.484 151.861 129.646C156.406 129.807 157.541 127.211 163.063 127.211C168.584 127.211 171.504 130.945 175.238 130.945C178.973 130.945 178.809 127.049 183.841 126.888C188.873 126.726 191.146 131.92 193.582 131.92C198.29 131.92 195.855 126.562 200.561 126.401C205.27 126.239 205.106 132.568 208.19 132.568C211.274 132.568 211.112 126.562 215.008 126.075C218.905 125.588 218.743 139.712 219.879 143.119C222.962 134.191 224.423 117.309 219.879 117.309C215.334 117.309 215.657 127.211 211.763 127.372C207.867 127.534 210.302 119.093 205.109 118.444C199.915 117.796 199.915 125.75 195.855 126.073C191.797 126.398 192.607 118.444 186.927 118.444C181.247 118.444 180.596 124.45 176.212 124.45C171.829 124.45 170.532 118.444 163.063 118.444C158.031 118.444 155.434 122.179 150.887 122.179C146.34 122.179 141.196 118.536 134.979 117.957C127.999 117.309 124.103 118.931 119.719 119.093V119.095Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.031 126.24C219.615 115.332 220.256 132.733 219.876 142.797C218.74 130.134 217.602 128.805 216.953 127.376C216.141 125.589 215.005 126.076 214.031 126.24Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.719 133.545H121.505",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.719 138.738H121.505",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.399 130.945H127.186",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.399 136.143H127.186",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.399 141.335H127.186",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.295 130.945H131.082",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.295 136.143H131.082",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.295 141.335H131.082",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.192 130.945H134.979",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.192 136.143H134.979",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.192 141.335H134.979",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.088 130.945H138.874",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.088 136.143H138.874",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.088 141.335H138.874",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.984 130.945H142.771",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.984 136.143H142.771",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.984 141.335H142.771",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.88 130.945H146.666",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.88 136.143H146.666",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.88 141.335H146.666",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.777 130.945H150.564",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.777 136.143H150.564",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.777 141.335H150.564",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.671 130.945H154.458",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.671 136.143H154.458",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.671 141.335H154.458",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.567 130.945H158.354",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.567 136.143H158.354",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.567 141.335H158.354",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.463 130.945H162.249",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.463 136.143H162.249",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.463 141.335H162.249",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.359 130.945H166.146",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.359 136.143H166.146",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.359 141.335H166.146",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.255 130.945H170.042",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.255 136.143H170.042",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.255 141.335H170.042",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.151 130.945H173.938",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.151 136.143H173.938",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.151 141.335H173.938",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.047 130.945H177.833",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.047 136.143H177.833",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.047 141.335H177.833",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.944 130.945H181.731",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.944 136.143H181.731",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.944 141.335H181.731",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.838 130.945H185.624",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.838 136.143H185.624",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.838 141.335H185.624",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.734 130.945H189.521",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.734 136.143H189.521",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.734 141.335H189.521",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.424 130.945H201.21",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.424 136.143H201.21",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.424 141.335H201.21",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.319 130.945H205.106",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.319 136.143H205.106",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.319 141.335H205.106",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.108 130.945H212.895",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.108 136.143H212.895",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.108 141.335H212.895",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.631 136.143H193.417",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.631 141.335H193.417",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.526 136.143H197.313",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.526 141.335H197.313",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.667 130.945H123.454",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.667 136.143H123.454",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.667 141.335H123.454",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.615 133.545H125.402",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.615 138.738H125.402",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.511 133.545H129.297",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.511 138.738H129.297",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.408 133.545H133.195",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.408 138.738H133.195",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.301 133.545H137.087",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.301 138.738H137.087",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.197 133.545H140.984",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.197 138.738H140.984",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.095 133.545H144.881",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.095 138.738H144.881",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.99 133.545H148.777",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.99 138.738H148.777",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.887 133.545H152.673",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.887 138.738H152.673",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.782 133.545H156.569",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.782 138.738H156.569",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.68 133.545H160.466",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.68 138.738H160.466",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.572 133.545H164.359",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.572 138.738H164.359",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.469 133.545H168.255",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.469 138.738H168.255",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.365 133.545H172.152",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.365 138.738H172.152",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.262 133.545H176.048",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.262 138.738H176.048",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.157 133.545H179.944",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.157 138.738H179.944",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.053 133.545H183.839",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.053 138.738H183.839",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.95 133.545H187.737",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.95 138.738H187.737",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 133.545H191.633",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.847 138.738H191.633",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.74 133.545H195.527",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.74 138.738H195.527",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.636 133.545H199.422",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.636 138.738H199.422",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.532 133.545H203.319",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.532 138.738H203.319",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.429 133.545H207.215",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.429 138.738H207.215",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.324 133.545H211.111",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.324 138.738H211.111",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.221 133.545H215.007",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.221 138.738H215.007",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.118 133.545H218.579",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.118 138.738H218.905",
    stroke: "#615E66",
    strokeWidth: 0.248485
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.455 126.24C203.245 125.129 199.91 124.779 197.962 127.375C201.21 125.102 202.815 126.762 203.806 127.862C205.267 129.485 205.267 132.84 208.515 132.407C205.593 129.972 206.405 128.024 204.457 126.24H204.455Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.527 126.338C186.74 125.111 181.567 125.265 179.132 128.836C182.216 125.914 185.689 127.044 187.086 127.536C189.847 128.51 190.657 132.19 193.904 131.758C191.355 131.109 191.126 128.125 188.527 126.338Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.443 126.241C165.358 125.644 161.276 125.754 156.405 128.676C162.086 126.402 165.559 127.21 166.956 127.702C169.717 128.676 171.665 130.624 175.071 130.785C172.522 130.137 170.85 127.215 167.443 126.241Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.685 125.914C136.276 125.588 131.724 125.439 124.103 128.187C132.382 126.565 136.969 127.228 139.198 127.375C143.581 127.663 146.526 129.494 151.861 129.648C147.875 129.037 145.075 126.428 139.685 125.914Z",
    fill: "#615E66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.8833 152.522H389.247V163.833H-11.8833V152.522Z",
    fill: "#CFCDC8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.759 156.121L-9.65062 156.055",
    stroke: "white",
    strokeWidth: 0.364662,
    strokeDasharray: "1.82 1.82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12.2462 142.062H389.247V146.686H-12.2462V142.062Z",
    fill: "#E1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.8833 143.368H389.247V149.538H-11.8833V143.368Z",
    fill: "#A9D395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.038 149.537H306.095L333.743 147.737H366.651L389.038 149.537Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.117 149.537H235.105L258.715 147.737H291.623L332.116 149.537H332.117Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.584 149.537H98.8247L138.339 147.737H215.288L247.584 149.537Z",
    fill: "#62AE80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.8833 163.643H389.247V166.56H-11.8833V163.643Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-11.8833 149.603H389.247V152.52H-11.8833V149.603Z",
    fill: "#FFF9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.9657 106.938H4.07617V112.7H-2.9657V106.938Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67871 108.452V112.698H4.07872V107.116L5.67871 108.449V108.452Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.52612 114.618H92.7539V116.539H-5.52612V114.618Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1406 119.421L94.2383 117.5H-7.61902L-6.24443 119.421H93.1406Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.508 119.42H93.0732V142.79H82.508V119.42Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.508 119.42H93.0732V121.662H82.508V119.42Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.16777 119.42H4.39746V121.662H-6.16777V119.42Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7516 134.468H90.833V142.791H84.7516V134.468Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7878 132.546H91.4717V133.185H83.7878V132.546Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8853 134.468L91.3975 133.187H83.9121L84.6814 134.468H90.8853Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.3507 135.748H88.9111V142.79H86.3507V135.748Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7099 128.384H89.5518V129.665H85.7099V128.384Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.991 136.388H88.2725V139.59H86.991V136.388Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.16777 119.42H4.39746V142.79H-6.16777V119.42Z",
    fill: "#FFF8E7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39735 119.42H82.5098V121.341H4.39735V119.42Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39735 121.341H82.5098V123.901H4.39735V121.341Z",
    fill: "#615E66",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6679 123.902H82.5098V142.791H78.6679V123.902Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1024 123.902H71.9443V142.791H68.1024V123.902Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.579 123.902H60.4209V142.791H56.579V123.902Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6923 123.902H49.5342V142.791H45.6923V123.902Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.409 123.902H40.251V142.791H36.409V123.902Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.207 123.902H29.6885V142.791H25.207V123.902Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0024 123.902H19.4443V142.791H14.0024V123.902Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39796 123.902H9.83984V142.791H4.39796V123.902Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2678 121.341H82.5098V122.301H80.2678V121.341Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5888 122.303H82.5098V142.791H80.5888V122.303Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39579 121.341H6.6377V122.301H4.39579V121.341Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.39836 122.303H6.31934V142.791H4.39836V122.303Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.7052 121.341H72.2656V122.301H69.7052V121.341Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0234 122.303H71.9443V142.791H70.0234V122.303Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1798 121.341H60.7402V122.301H58.1798V121.341Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5 122.303H60.4209V142.791H58.5V122.303Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.296 121.341H49.8564V122.301H47.296V121.341Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6133 122.303H49.5342V142.791H47.6133V122.303Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0909 121.341H38.6514V122.301H36.0909V121.341Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4091 122.303H38.3301V142.791H36.4091V122.303Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8858 121.341H27.4463V122.301H24.8858V121.341Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.204 122.303H27.125V142.791H25.204V122.303Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6817 121.341H16.2422V122.301H13.6817V121.341Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9989 122.303H15.9199V142.791H13.9989V122.303Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8323 113.657L93.5527 112.696H-6.96922L-6.24888 113.657H92.8323Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8323 114.618L93.5527 113.657H-6.96922L-6.24888 114.618H92.8323Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.406 117.5L95.1484 116.539H-8.56122L-7.81886 117.5H94.406Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6311 127.747C86.3929 127.747 85.3892 126.743 85.3892 125.505C85.3892 124.266 86.3929 123.263 87.6311 123.263C88.8693 123.263 89.873 124.266 89.873 125.505C89.873 126.743 88.8693 127.747 87.6311 127.747Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6305 127.103C86.7468 127.103 86.0305 126.387 86.0305 125.503C86.0305 124.62 86.7468 123.903 87.6305 123.903C88.5141 123.903 89.2305 124.62 89.2305 125.503C89.2305 126.387 88.5141 127.103 87.6305 127.103Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3359 107.576L44.5743 108.858L42.173 112.7C42.7586 112.7 44.1259 112.668 44.8952 112.54C46.4315 111.644 46.2821 109.5 46.015 108.539L46.3359 107.579V107.576Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6143 108.215L45.8525 109.335L43.4513 112.696C44.0369 112.696 45.4041 112.669 46.1735 112.557C47.7098 111.773 47.5603 109.896 47.2933 109.055L47.6143 108.215Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.8955 108.536L47.1338 109.577L44.7326 112.699C45.3182 112.699 46.6854 112.672 47.4548 112.569C48.991 111.841 48.8416 110.097 48.5745 109.318L48.8955 108.536Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4961 109.177L48.7344 110.056L46.3332 112.698C46.9188 112.698 48.286 112.676 49.0554 112.587C50.5917 111.97 50.4422 110.497 50.1752 109.836L50.4961 109.177Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4561 110.458L49.6944 111.019L47.2932 112.7C47.8788 112.7 49.2459 112.685 50.0153 112.629C51.5516 112.237 51.4021 111.298 51.1351 110.877L51.4561 110.458Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9719 107.576L40.7336 108.858L43.1348 112.7C42.5492 112.7 41.1819 112.668 40.4126 112.54C38.8763 111.644 39.0257 109.5 39.2928 108.539L38.9719 107.579V107.576Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6906 108.215L39.4523 109.335L41.8535 112.696C41.2679 112.696 39.9007 112.669 39.1313 112.557C37.595 111.773 37.7445 109.896 38.0116 109.055L37.6906 108.215Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4104 108.536L38.1721 109.577L40.5732 112.699C39.9876 112.699 38.6205 112.672 37.8511 112.569C36.3148 111.841 36.4643 110.097 36.7313 109.318L36.4104 108.536Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8088 109.177L36.5705 110.056L38.9717 112.698C38.3861 112.698 37.0188 112.676 36.2495 112.587C34.7132 111.97 34.8626 110.497 35.1297 109.836L34.8088 109.177Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8488 110.458L35.6105 111.019L38.0117 112.7C37.4261 112.7 36.0589 112.685 35.2896 112.629C33.7533 112.237 33.9027 111.298 34.1698 110.877L33.8488 110.458Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6532 112.058C41.5043 112.058 40.5729 111.127 40.5729 109.978C40.5729 108.829 41.5043 107.897 42.6532 107.897C43.8021 107.897 44.7334 108.829 44.7334 109.978C44.7334 111.127 43.8021 112.058 42.6532 112.058Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6531 111.418C41.8574 111.418 41.2123 110.773 41.2123 109.977C41.2123 109.181 41.8574 108.536 42.6531 108.536C43.4487 108.536 44.0938 109.181 44.0938 109.977C44.0938 110.773 43.4487 111.418 42.6531 111.418Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.701 124.118L90.8774 123.51C90.9362 123.307 90.7818 123.101 90.5662 123.101H89.7724C89.7307 123.101 89.6915 123.093 89.6572 123.079L87.7632 122.351C87.6799 122.319 87.5868 122.324 87.5059 122.363L85.5188 123.356C85.438 123.397 85.3424 123.4 85.2566 123.365L84.9209 123.231C84.7445 123.16 84.5461 123.258 84.4946 123.439L84.2986 124.113C84.279 124.181 84.2814 124.255 84.3108 124.318L84.5265 124.86C84.5681 124.958 84.5559 125.068 84.4971 125.156L84.3574 125.367C84.3035 125.45 84.2912 125.553 84.3182 125.647L84.5412 126.311C84.5706 126.404 84.5583 126.507 84.502 126.59L84.3696 126.786C84.3059 126.881 84.2986 127.004 84.3501 127.107L84.5167 127.438C84.5608 127.528 84.5608 127.634 84.5167 127.724L84.3305 128.092C84.2888 128.173 84.2864 128.268 84.3207 128.354L84.5216 128.864C84.5632 128.962 84.551 129.072 84.4922 129.16L84.3844 129.322C84.3133 129.43 84.3133 129.569 84.3844 129.677L84.4849 129.824C84.5486 129.92 84.5559 130.042 84.5044 130.145L84.3378 130.476C84.2937 130.567 84.2937 130.672 84.3378 130.763L84.5265 131.137C84.5657 131.213 84.5583 131.304 84.5093 131.373C84.4064 131.529 84.5191 131.74 84.7078 131.74H90.4951C90.603 131.74 90.7034 131.686 90.7647 131.598L90.8872 131.414C90.9509 131.319 90.9583 131.196 90.9068 131.093L90.7402 130.763C90.6961 130.672 90.6961 130.567 90.7402 130.476L90.9068 130.145C90.9583 130.042 90.9509 129.92 90.8872 129.824L90.7868 129.677C90.7157 129.569 90.7157 129.43 90.7868 129.322L90.8946 129.16C90.9534 129.072 90.9656 128.962 90.9239 128.864L90.7231 128.354C90.6888 128.268 90.6912 128.173 90.7329 128.092L90.9191 127.724C90.9632 127.634 90.9632 127.528 90.9191 127.438L90.7402 127.082C90.6961 126.992 90.6961 126.886 90.7402 126.796L90.9264 126.428C90.968 126.347 90.9705 126.252 90.9362 126.166L90.7353 125.656C90.6937 125.558 90.7059 125.448 90.7647 125.36L90.8995 125.159C90.9583 125.071 90.9705 124.96 90.9288 124.862L90.7132 124.321C90.6838 124.255 90.6814 124.181 90.701 124.115V124.118Z",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.92614 134.468H2.15527V142.791H-3.92614V134.468Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.88595 132.546H2.79785V133.185H-4.88595V132.546Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.2067 134.468L2.71875 133.187H-4.76657L-3.99723 134.468H2.2067Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.32607 135.748H0.234375V142.79H-2.32607V135.748Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.96598 128.384H0.875977V129.665H-2.96598V128.384Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.04464 127.747C-2.28283 127.747 -3.28661 126.743 -3.28661 125.505C-3.28661 124.266 -2.28283 123.263 -1.04464 123.263C0.193542 123.263 1.19727 124.266 1.19727 125.505C1.19727 126.743 0.193542 127.747 -1.04464 127.747Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.04432 127.103C-1.92797 127.103 -2.64431 126.387 -2.64431 125.503C-2.64431 124.62 -1.92797 123.903 -1.04432 123.903C-0.160679 123.903 0.555664 124.62 0.555664 125.503C0.555664 126.387 -0.160679 127.103 -1.04432 127.103Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.02521 124.118L2.20161 123.51C2.26042 123.307 2.10605 123.101 1.89043 123.101H1.09657C1.05492 123.101 1.01572 123.093 0.981418 123.079L-0.915035 122.351C-0.998342 122.319 -1.09146 122.324 -1.16987 122.363L-3.157 123.356C-3.23786 123.397 -3.33338 123.4 -3.41913 123.365L-3.75484 123.231C-3.93125 123.16 -4.12972 123.258 -4.18117 123.439L-4.3772 124.113C-4.3968 124.181 -4.39434 124.255 -4.36494 124.318L-4.14929 124.86C-4.10763 124.958 -4.11991 125.068 -4.17872 125.156L-4.3184 125.367C-4.3723 125.45 -4.38453 125.553 -4.35758 125.647L-4.13463 126.311C-4.10523 126.404 -4.11746 126.507 -4.17381 126.59L-4.30613 126.786C-4.36984 126.881 -4.37721 127.004 -4.32575 127.107L-4.1591 127.438C-4.11499 127.528 -4.11499 127.634 -4.1591 127.724L-4.34532 128.092C-4.38697 128.173 -4.38943 128.268 -4.35513 128.354L-4.15419 128.864C-4.11254 128.962 -4.12482 129.072 -4.18362 129.16L-4.29142 129.322C-4.36247 129.43 -4.36247 129.569 -4.29142 129.677L-4.19343 129.824C-4.12973 129.92 -4.12236 130.042 -4.17381 130.145L-4.34041 130.476C-4.38451 130.567 -4.38451 130.672 -4.34041 130.763L-4.15174 131.137C-4.11254 131.213 -4.1199 131.304 -4.16891 131.373C-4.27182 131.529 -4.15909 131.74 -3.97043 131.74H1.81691C1.92472 131.74 2.02521 131.686 2.08646 131.598L2.20897 131.414C2.27268 131.319 2.27999 131.196 2.22853 131.093L2.06193 130.763C2.01783 130.672 2.01783 130.567 2.06193 130.476L2.22853 130.145C2.27999 130.042 2.27268 129.92 2.20897 129.824L2.11093 129.677C2.03987 129.569 2.03987 129.43 2.11093 129.322L2.21878 129.16C2.27759 129.072 2.28981 128.962 2.24815 128.864L2.04722 128.354C2.01292 128.268 2.01538 128.173 2.05703 128.092L2.24325 127.724C2.28735 127.634 2.28735 127.528 2.24325 127.438L2.06439 127.082C2.02028 126.992 2.02028 126.886 2.06439 126.796L2.2506 126.428C2.29226 126.347 2.29472 126.252 2.26042 126.166L2.05948 125.656C2.01783 125.558 2.03011 125.448 2.08891 125.36L2.22369 125.159C2.28249 125.071 2.29471 124.96 2.25306 124.862L2.03747 124.321C2.00807 124.255 2.0056 124.181 2.02521 124.115V124.118Z",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8312 106.938H89.873V112.7H82.8312V106.938Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2281 108.452V112.698H82.8281V107.116L81.2281 108.449V108.452Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3365 109.256L90.724 112.441C90.6946 112.593 90.5598 112.701 90.4079 112.701H55.9385C55.762 112.701 55.6175 112.556 55.6175 112.38V111.532C55.6175 111.458 55.642 111.387 55.6885 111.331L56.2006 110.691C56.2398 110.642 56.2618 110.584 56.2667 110.522L56.4138 109.06C56.4162 109.03 56.4236 109.003 56.4334 108.976L56.8524 107.888C56.9479 107.633 57.3228 107.675 57.362 107.947C57.4036 108.231 57.8006 108.258 57.8815 107.981L57.8937 107.93C57.9746 107.658 58.3617 107.665 58.4278 107.94L58.5209 108.31C58.592 108.594 59.0012 108.584 59.06 108.297L59.1041 108.067C59.1531 107.834 59.4814 107.827 59.5402 108.057L59.5599 108.138C59.6138 108.349 59.9151 108.342 59.9568 108.128C59.9984 107.928 60.2802 107.905 60.3513 108.099L60.4982 108.511C60.5742 108.716 60.8707 108.704 60.927 108.494C60.9932 108.256 61.3362 108.28 61.3681 108.523L61.3754 108.562C61.4073 108.819 61.7723 108.837 61.8336 108.584L61.988 107.925C62.0468 107.69 62.3751 107.673 62.4511 107.905L62.5099 108.075C62.5809 108.285 62.8872 108.248 62.9068 108.028C62.9264 107.81 63.2278 107.768 63.3013 107.974L63.3846 108.197C63.4654 108.422 63.784 108.422 63.8648 108.197L63.9898 107.852C64.0731 107.624 64.399 107.641 64.4603 107.876L64.4945 108.016C64.5484 108.241 64.8743 108.229 64.9135 107.999C64.9527 107.776 65.2663 107.754 65.3325 107.972L65.4722 108.435C65.5359 108.638 65.8274 108.626 65.8715 108.42L65.8911 108.329C65.9303 108.155 66.1705 108.138 66.2342 108.305C66.3004 108.481 66.5601 108.447 66.5797 108.261V108.231C66.6017 108.035 66.8737 108.001 66.9423 108.187L67.0035 108.354C67.0844 108.574 67.4029 108.543 67.4397 108.31L67.4691 108.128C67.5009 107.91 67.8072 107.901 67.8587 108.114L67.866 108.141C67.915 108.351 68.2189 108.337 68.2458 108.124L68.2629 108.001C68.2923 107.8 68.5839 107.795 68.6109 107.999C68.6427 108.19 68.9122 108.202 68.9563 108.016L69.0004 107.837C69.0543 107.619 69.368 107.624 69.417 107.844L69.4562 108.021C69.515 108.29 69.8972 108.29 69.956 108.021L69.9659 107.979C70.0247 107.709 70.402 107.697 70.4779 107.962L70.5367 108.16C70.6225 108.462 71.0488 108.464 71.1419 108.163C71.235 107.856 71.6712 107.864 71.7545 108.173L71.779 108.271C71.8647 108.592 72.3229 108.587 72.3989 108.261L72.4944 107.849C72.5557 107.599 72.9134 107.604 72.9624 107.856L72.982 107.94C73.031 108.185 73.3814 108.177 73.4206 107.93C73.4549 107.702 73.7685 107.67 73.8494 107.883L73.967 108.19C74.065 108.452 74.4497 108.405 74.4889 108.128C74.5281 107.834 74.9446 107.807 75.0206 108.094L75.0647 108.271C75.1406 108.55 75.5327 108.567 75.6282 108.295L75.6723 108.177C75.7581 107.942 76.0938 107.957 76.16 108.197C76.231 108.454 76.5985 108.447 76.6598 108.187L76.7333 107.861C76.7921 107.616 77.1229 107.584 77.2258 107.815L77.3165 108.013C77.39 108.18 77.6374 108.155 77.6742 107.977C77.7183 107.776 78.0074 107.781 78.0466 107.981L78.1128 108.312C78.1569 108.535 78.4803 108.525 78.5097 108.3C78.5391 108.075 78.8625 108.065 78.9066 108.288L78.9311 108.41C78.9801 108.648 79.3182 108.648 79.3672 108.41L79.3918 108.288C79.4408 108.04 79.796 108.045 79.8401 108.293C79.8842 108.55 80.2591 108.53 80.291 108.271C80.3204 108.023 80.6708 107.989 80.7369 108.231C80.7957 108.44 81.0824 108.459 81.1657 108.261L81.1755 108.239C81.2588 108.05 81.5284 108.048 81.6117 108.236L81.793 108.65C81.8959 108.881 82.2119 108.908 82.354 108.697L82.7731 108.067C82.8686 107.923 83.0867 107.935 83.1675 108.092C83.2631 108.288 83.5546 108.246 83.5938 108.03L83.6012 107.989C83.6502 107.736 84.0055 107.719 84.0741 107.969L84.0863 108.023C84.15 108.253 84.4637 108.278 84.5641 108.062L84.8214 107.496C84.9072 107.31 85.1791 107.332 85.2355 107.528L85.3163 107.82C85.3653 107.996 85.6226 107.974 85.6398 107.79C85.6569 107.609 85.9093 107.584 85.9632 107.758L86.0073 107.915C86.0661 108.101 86.3283 108.101 86.3847 107.915L86.4263 107.776C86.4973 107.543 86.8305 107.55 86.8869 107.785L86.9163 107.896C86.9702 108.121 87.2937 108.109 87.3353 107.881C87.3745 107.665 87.671 107.641 87.7494 107.847L87.8229 108.05C87.9136 108.3 88.2738 108.285 88.3448 108.028L88.3889 107.866C88.4502 107.636 88.7736 107.629 88.8495 107.854C88.9206 108.075 89.2342 108.075 89.3053 107.854L89.3175 107.82C89.3935 107.589 89.7218 107.589 89.7978 107.82L89.9105 108.158C89.9644 108.322 90.1825 108.361 90.2878 108.226C90.4201 108.065 90.6774 108.155 90.6774 108.364V108.981C90.6774 109.158 90.8979 109.236 91.0106 109.101C91.1356 108.952 91.3757 109.067 91.3414 109.258L91.3365 109.256Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.74931 109.256L-4.13676 112.441C-4.10736 112.593 -3.97259 112.701 -3.82067 112.701H30.6487C30.8252 112.701 30.9697 112.556 30.9697 112.38V111.532C30.9697 111.458 30.9452 111.387 30.8987 111.331L30.3866 110.691C30.3474 110.642 30.3253 110.584 30.3204 110.522L30.1734 109.06C30.171 109.03 30.1637 109.003 30.1539 108.976L29.7348 107.888C29.6393 107.633 29.2644 107.675 29.2252 107.947C29.1836 108.231 28.7866 108.258 28.7057 107.981L28.6935 107.93C28.6126 107.658 28.2255 107.665 28.1594 107.94L28.0663 108.31C27.9952 108.594 27.586 108.584 27.5272 108.297L27.4831 108.067C27.4341 107.834 27.1058 107.827 27.047 108.057L27.0274 108.138C26.9735 108.349 26.6721 108.342 26.6304 108.128C26.5888 107.928 26.307 107.905 26.236 108.099L26.0889 108.511C26.013 108.716 25.7165 108.704 25.6602 108.494C25.594 108.256 25.251 108.28 25.2191 108.523L25.2118 108.562C25.1799 108.819 24.8149 108.837 24.7536 108.584L24.5992 107.925C24.5404 107.69 24.2121 107.673 24.1361 107.905L24.0773 108.075C24.0063 108.285 23.7 108.248 23.6804 108.028C23.6608 107.81 23.3594 107.768 23.2859 107.974L23.2026 108.197C23.1217 108.422 22.8032 108.422 22.7224 108.197L22.5974 107.852C22.5141 107.624 22.1882 107.641 22.127 107.876L22.0927 108.016C22.0387 108.241 21.7129 108.229 21.6737 107.999C21.6345 107.776 21.3209 107.754 21.2547 107.972L21.115 108.435C21.0513 108.638 20.7598 108.626 20.7157 108.42L20.6961 108.329C20.6568 108.155 20.4168 108.138 20.353 108.305C20.2869 108.481 20.0271 108.447 20.0075 108.261V108.231C19.9855 108.035 19.7135 108.001 19.6449 108.187L19.5837 108.354C19.5028 108.574 19.1843 108.543 19.1475 108.31L19.1181 108.128C19.0863 107.91 18.78 107.901 18.7285 108.114L18.7212 108.141C18.6722 108.351 18.3683 108.337 18.3414 108.124L18.3243 108.001C18.2949 107.8 18.0033 107.795 17.9763 107.999C17.9445 108.19 17.675 108.202 17.6308 108.016L17.5868 107.837C17.5329 107.619 17.2192 107.624 17.1702 107.844L17.131 108.021C17.0722 108.29 16.69 108.29 16.6311 108.021L16.6213 107.979C16.5625 107.709 16.1852 107.697 16.1093 107.962L16.0505 108.16C15.9647 108.462 15.5384 108.464 15.4453 108.163C15.3522 107.856 14.916 107.864 14.8327 108.173L14.8082 108.271C14.7225 108.592 14.2643 108.587 14.1883 108.261L14.0928 107.849C14.0315 107.599 13.6737 107.604 13.6247 107.856L13.6052 107.94C13.5562 108.185 13.2058 108.177 13.1666 107.93C13.1323 107.702 12.8187 107.67 12.7378 107.883L12.6202 108.19C12.5197 108.452 12.1375 108.405 12.0983 108.128C12.0591 107.834 11.6426 107.807 11.5666 108.094L11.5225 108.271C11.4466 108.55 11.0545 108.567 10.959 108.295L10.9149 108.177C10.8291 107.942 10.4934 107.957 10.4273 108.197C10.3562 108.454 9.98868 108.447 9.92743 108.187L9.85391 107.861C9.79511 107.616 9.46433 107.584 9.36142 107.815L9.27073 108.013C9.19723 108.18 8.94977 108.155 8.91301 107.977C8.86891 107.776 8.57978 107.781 8.54058 107.981L8.47442 108.312C8.43031 108.535 8.10692 108.525 8.07752 108.3C8.04811 108.075 7.72466 108.065 7.68055 108.288L7.65609 108.41C7.60708 108.648 7.26895 108.648 7.21995 108.41L7.19542 108.288C7.14642 108.04 6.79118 108.045 6.74707 108.293C6.70297 108.55 6.32807 108.53 6.29622 108.271C6.26681 108.023 5.91642 107.989 5.85026 108.231C5.79146 108.44 5.50478 108.459 5.42148 108.261L5.41167 108.239C5.32836 108.05 5.05889 108.048 4.97558 108.236L4.79427 108.65C4.69136 108.881 4.37528 108.908 4.23317 108.697L3.81419 108.067C3.71863 107.923 3.50054 107.935 3.41968 108.092C3.32412 108.288 3.03255 108.246 2.99335 108.03L2.98599 107.989C2.93699 107.736 2.58173 107.719 2.51312 107.969L2.50086 108.023C2.43715 108.253 2.12354 108.278 2.02308 108.062L1.7658 107.496C1.68004 107.31 1.40808 107.332 1.35173 107.528L1.27085 107.82C1.22185 107.996 0.964559 107.974 0.947408 107.79C0.930256 107.609 0.677929 107.584 0.624024 107.758L0.579877 107.915C0.521073 108.101 0.258951 108.101 0.202597 107.915L0.160903 107.776C0.0898468 107.543 -0.243352 107.55 -0.299706 107.785L-0.329138 107.896C-0.383042 108.121 -0.706459 108.109 -0.748112 107.881C-0.787316 107.665 -1.08378 107.641 -1.16218 107.847L-1.2357 108.05C-1.32636 108.3 -1.68651 108.285 -1.75756 108.028L-1.80171 107.866C-1.86297 107.636 -2.18636 107.629 -2.26232 107.854C-2.33338 108.075 -2.64703 108.075 -2.71808 107.854L-2.73035 107.82C-2.8063 107.589 -3.13462 107.589 -3.21058 107.82L-3.32328 108.158C-3.37718 108.322 -3.59526 108.361 -3.70062 108.226C-3.83293 108.065 -4.09016 108.155 -4.09016 108.364V108.981C-4.09016 109.158 -4.3107 109.236 -4.42341 109.101C-4.54837 108.952 -4.78852 109.067 -4.75421 109.258L-4.74931 109.256Z",
    fill: "#FFF9DE",
    stroke: "#615E66",
    strokeWidth: 0.24502,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8086 112.537L30.7498 109.834C30.74 109.379 30.37 109.016 29.9142 109.016C29.4658 109.016 29.0959 109.371 29.0787 109.82L28.9758 112.537L28.8852 109.783C28.868 109.357 28.5176 109.016 28.0913 109.016C27.665 109.016 27.3146 109.354 27.2974 109.781L27.1945 112.537L27.0892 109.805C27.0721 109.364 26.7119 109.016 26.2708 109.016C25.8298 109.016 25.4671 109.364 25.4524 109.805L25.3495 112.537L25.2221 109.71C25.2025 109.32 24.8816 109.014 24.492 109.014C24.0926 109.014 23.7643 109.34 23.7643 109.741V112.535",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7666 112.537L23.7078 109.834C23.698 109.379 23.328 109.016 22.8722 109.016C22.4239 109.016 22.0539 109.371 22.0367 109.82L21.9339 112.537L21.8432 109.783C21.826 109.357 21.4756 109.016 21.0493 109.016C20.623 109.016 20.2726 109.354 20.2554 109.781L20.1526 112.537L20.0472 109.805C20.0301 109.364 19.6699 109.016 19.2288 109.016C18.7878 109.016 18.4251 109.364 18.4104 109.805L18.3075 112.537L18.1801 109.71C18.1605 109.32 17.8396 109.014 17.45 109.014C17.0506 109.014 16.7223 109.34 16.7223 109.741V112.535",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7217 112.537L16.6629 109.834C16.6531 109.379 16.2806 109.016 15.8273 109.016C15.3789 109.016 15.009 109.371 14.9918 109.82L14.8889 112.537L14.7982 109.783C14.7811 109.357 14.4307 109.016 14.0044 109.016C13.5781 109.016 13.2277 109.354 13.2105 109.781L13.1076 112.537L13.0023 109.805C12.9851 109.364 12.6249 109.016 12.1839 109.016C11.7429 109.016 11.3802 109.364 11.3655 109.805L11.2626 112.537L11.1352 109.71C11.1156 109.32 10.7946 109.014 10.4051 109.014C10.0057 109.014 9.67735 109.34 9.67735 109.741V112.535",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67969 112.537L9.62089 109.834C9.61108 109.379 9.23862 109.016 8.78533 109.016C8.33694 109.016 7.96698 109.371 7.94983 109.82L7.84694 112.537L7.75626 109.783C7.7391 109.357 7.38873 109.016 6.96239 109.016C6.53606 109.016 6.18568 109.354 6.16853 109.781L6.06564 112.537L5.9603 109.805C5.94315 109.364 5.58295 109.016 5.14191 109.016C4.70087 109.016 4.33822 109.364 4.32352 109.805L4.22063 112.537L4.09322 109.71C4.07362 109.32 3.75264 109.014 3.36306 109.014C2.96368 109.014 2.63536 109.34 2.63536 109.741V112.535",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.63574 112.537L2.57694 109.834C2.56714 109.379 2.19467 109.016 1.74138 109.016C1.293 109.016 0.923037 109.371 0.905886 109.82L0.802997 112.537L0.712311 109.783C0.695159 109.357 0.344783 109.016 -0.0815522 109.016C-0.507887 109.016 -0.858263 109.354 -0.875415 109.781L-0.978304 112.537L-1.08365 109.805C-1.1008 109.364 -1.461 109.016 -1.90203 109.016C-2.34307 109.016 -2.70572 109.364 -2.72042 109.805L-2.82331 112.537L-2.95073 109.71C-2.97033 109.32 -3.2913 109.014 -3.68088 109.014C-4.08027 109.014 -4.40859 109.34 -4.40859 109.741V112.535",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3135 112.537L91.2547 109.834C91.2449 109.379 90.8749 109.016 90.4192 109.016C89.9708 109.016 89.6008 109.371 89.5836 109.82L89.4807 112.537L89.3901 109.783C89.373 109.357 89.0225 109.016 88.5962 109.016C88.1698 109.016 87.8195 109.354 87.8023 109.781L87.6994 112.537L87.5941 109.805C87.5769 109.364 87.2167 109.016 86.7757 109.016C86.3347 109.016 85.9721 109.364 85.9574 109.805L85.8544 112.537L85.727 109.71C85.7074 109.32 85.3864 109.014 84.9969 109.014C84.5975 109.014 84.2691 109.34 84.2691 109.741V112.535",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2695 112.537L84.2107 109.834C84.2009 109.379 83.831 109.016 83.3752 109.016C82.9268 109.016 82.5568 109.371 82.5397 109.82L82.4368 112.537L82.3462 109.783C82.329 109.357 81.9786 109.016 81.5522 109.016C81.1259 109.016 80.7755 109.354 80.7584 109.781L80.6555 112.537L80.5501 109.805C80.533 109.364 80.1728 109.016 79.7318 109.016C79.2907 109.016 78.9281 109.364 78.9134 109.805L78.8105 112.537L78.6831 109.71C78.6635 109.32 78.3425 109.014 77.9529 109.014C77.5535 109.014 77.2252 109.34 77.2252 109.741V112.535",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2275 112.537L77.1687 109.834C77.1589 109.379 76.789 109.016 76.3332 109.016C75.8849 109.016 75.5148 109.371 75.4977 109.82L75.3948 112.537L75.3041 109.783C75.287 109.357 74.9366 109.016 74.5102 109.016C74.0839 109.016 73.7335 109.354 73.7164 109.781L73.6135 112.537L73.5082 109.805C73.491 109.364 73.1308 109.016 72.6898 109.016C72.2487 109.016 71.8861 109.364 71.8714 109.805L71.7685 112.537L71.6411 109.71C71.6215 109.32 71.3005 109.014 70.9109 109.014C70.5115 109.014 70.1832 109.34 70.1832 109.741V112.535",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1855 112.537L70.1267 109.834C70.1169 109.379 69.747 109.016 69.2912 109.016C68.8429 109.016 68.4728 109.371 68.4557 109.82L68.3528 112.537L68.2621 109.783C68.245 109.357 67.8946 109.016 67.4683 109.016C67.0419 109.016 66.6915 109.354 66.6744 109.781L66.5715 112.537L66.4662 109.805C66.449 109.364 66.0888 109.016 65.6478 109.016C65.2067 109.016 64.8441 109.364 64.8294 109.805L64.7265 112.537L64.5991 109.71C64.5795 109.32 64.2585 109.014 63.8689 109.014C63.4695 109.014 63.1412 109.34 63.1412 109.741V112.535",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1406 112.537L63.0818 109.834C63.072 109.379 62.7021 109.016 62.2463 109.016C61.7979 109.016 61.4279 109.371 61.4108 109.82L61.3079 112.537L61.2172 109.783C61.2 109.357 60.8497 109.016 60.4233 109.016C59.997 109.016 59.6466 109.354 59.6295 109.781L59.5266 112.537L59.4212 109.805C59.4041 109.364 59.0439 109.016 58.6028 109.016C58.1618 109.016 57.7992 109.364 57.7845 109.805L57.6816 112.537L57.5542 109.71C57.5346 109.32 57.2136 109.014 56.824 109.014C56.4246 109.014 56.0963 109.34 56.0963 109.741V112.535",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7516 113.657H90.833V115.578H84.7516V113.657Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6255 114.618H70.665C70.1357 114.618 69.7045 115.047 69.7045 115.579C69.7045 116.108 70.1333 116.539 70.665 116.539H71.6255C72.1547 116.539 72.5859 116.11 72.5859 115.579C72.5859 115.049 72.1572 114.618 71.6255 114.618Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07617 110.145C3.00053 110.225 2.15525 111.125 2.15525 112.22V112.7H4.07617V110.145Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.204 111.097C25.204 110.568 25.6328 110.137 26.1645 110.137C26.6962 110.137 27.125 110.565 27.125 111.097V112.697H25.204V111.097Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0028 111.097C14.0028 110.568 14.4317 110.137 14.9634 110.137C15.4951 110.137 15.9238 110.565 15.9238 111.097V112.697H14.0028V111.097Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1011 114.618H59.1405C58.6113 114.618 58.1801 115.047 58.1801 115.579C58.1801 116.108 58.6089 116.539 59.1405 116.539H60.1011C60.6303 116.539 61.0615 116.11 61.0615 115.579C61.0615 115.049 60.6328 114.618 60.1011 114.618Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4858 114.618H25.5253C24.9961 114.618 24.5649 115.047 24.5649 115.579C24.5649 116.108 24.9936 116.539 25.5253 116.539H26.4858C27.015 116.539 27.4463 116.11 27.4463 115.579C27.4463 115.049 27.0175 114.618 26.4858 114.618Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2817 114.618H14.3212C13.792 114.618 13.3607 115.047 13.3607 115.579C13.3607 116.108 13.792 116.539 14.3212 116.539H15.2817C15.8109 116.539 16.2422 116.11 16.2422 115.579C16.2422 115.049 15.8109 114.618 15.2817 114.618Z",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4336 110.145C91.358 110.225 90.5126 111.125 90.5126 112.22V112.7H92.4336V110.145Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8281 110.145C83.9037 110.225 84.749 111.125 84.749 112.22V112.7H82.8281V110.145Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3446 111.097C70.3446 110.568 70.7735 110.137 71.3052 110.137C71.8369 110.137 72.2656 110.565 72.2656 111.097V112.697H70.3446V111.097Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8193 111.097C58.8193 110.568 59.2481 110.137 59.7798 110.137C60.3115 110.137 60.7402 110.565 60.7402 111.097V112.697H58.8193V111.097Z",
    fill: "white",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.92614 113.657H2.15527V115.578H-3.92614V113.657Z",
    fill: "#FAEAC7",
    stroke: "#615E66",
    strokeWidth: 0.24502
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 165.574H0V812.301H375V165.574Z",
    fill: "url(#paint6_linear_6001_52307)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6001_52307",
    x1: 125.463,
    y1: 27.7058,
    x2: 599.966,
    y2: 442.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFD1E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988023,
    stopColor: "#1934E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6001_52307",
    x1: 139.365,
    y1: 0.30078,
    x2: 344.821,
    y2: 803.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988023,
    stopColor: "#A7D4F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6001_52307",
    x1: -180.973,
    y1: 148.605,
    x2: -180.973,
    y2: 76.8956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6001_52307",
    x1: -180.973,
    y1: 148.605,
    x2: -180.973,
    y2: 76.8956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6001_52307",
    x1: 35.405,
    y1: 93.675,
    x2: 35.405,
    y2: 162.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6001_52307",
    x1: 549.577,
    y1: 162.049,
    x2: 549.577,
    y2: 63.9537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1DED4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6001_52307",
    x1: 187.5,
    y1: 165.574,
    x2: 187.5,
    y2: 729.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D5C3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6001_52307"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 166,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackPlanMobile);
export default __webpack_public_path__ + "static/media/BackPlanMobile.4fe2a2f985a4e1d586e2.svg";
export { ForwardRef as ReactComponent };